import React, {Component, useEffect} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {UncontrolledCollapse, Button, CardBody, Card, Modal, ModalHeader, ModalBody, ModalFooter, Collapse ,FormGroup, Radio} from 'reactstrap';
import jwt_decode from "jwt-decode";
import Scanner from './Scanner';
import Result from './Result';
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import * as moment from "moment-timezone";
import ModalD from "react-awesome-modal";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import {Row, Col} from 'reactstrap';
import {confirmAlert} from 'react-confirm-alert';
import loaderGIF from "../assets/loader.gif";

var state = { selectedFile: null };
var timestamp = new Date().getTime();

class InnovitiSupportModes extends Component {
  constructor(props) {
    super(props);
    this.cameraNumber = 0;
    this.state = {

      myTicketData: [],
      MyCloseTicketData: [],
      myStockSummary: [],
      checkAttandance: [],
      markAttandance: [],
      showHideAttendanceBtn: true,
      showHideOtherBtn: true,
      modalIssue: false,
      modalIssue1: false,
      allStoreUtid:[],
      currentICMTicket:"",
      icmCloseMessage:"",
      disableSubmit:{
        visibility:'hidden'
      },
      
      //---------------------------

      //-------------Virtual SRO--------------
      confirmAWBModal:false,
      paperRollTicketId:'',
      AWBViewModal:false,
      paperRollTicketData:{},
      bulkClosure:false,

      //--------------------------
      openRetrievalModal:false,
      retrievalType:'available',

      //--------------------------------------
      uploadButtonId:'',
      jobSheetData:[],
      icmParentIDs:[],
      invCheckButton:false,
      kycCheckButton:false,
      isMobile: true,
      ICMTicketView:false,
      resolvedTicketView:false,
      openTicketView:false,
      loader:'',
      totalICMtcikets:0,
      onlyICMTcketData:[],
      GPSPermission:true,
      uploadingButtonMessage:"",
      invCheckNoteMessage:"",
      imageDataURL: null,
      openCamera:false,
      captureButton:'',
      finalUploadButton:'none',
      cameraResetButton:'none',
      storeLocation:{},
      captureImageButton:{
          disabled:true,
      },
      uploadImageButton:{
          disabled:true,
      },
      cameraSwitchButton:'',
      uploadButtonName:'pe-7s-cloud-upload',
      //---------------------------
      disableSubmitRemark:{
        visibility:'hidden'
      },
      finalSubmitButtonName:"Save",
      invCheckNote:false,
      invCheckNoteError:false,
      invCheckImgUpload:false,
      storeUtIdData:[],
      storeImageData:{},
      ticketDetails: {
        priority: "",
        ticketId: "",
        utid: "",
        store: "",
        storeAddress: "",
        issueSubCategory: "",
        dispatcherDate: "",
        dispatcherSource: "",
        issueType: "",
        dispatchTime: "",
        iskuName: "",
        iskuDesc: "",
        merchantContactNumber: "",
        cfRetrievalTSN: "",
        proactiveChecks: ""
      },
      totalMyTicketOpenCount: 0,
      totalMyTicketCloseCount: 0,
      collectWorkOrder: [],
      returnWorkOrder: [],
      lattitude: '',
      longitude: '',
      scanning: false,
      results: [],
      barCode: '',
      deviceValues: [],
      deviceList: [],
      deviceIds: [],
      productValues: [],
      productList: [],
      productIds: [],
      versionValues: [],
      versionList: [],
      versionIds: [],
      scanmodalIssue:false,
      store_manager_name:"",
      store_manager_number:"",
      validate_msg:"",
      barCode3:"",
      adapter:0,
      usb:0
    }
    this._scan = this._scan.bind(this);
    this._onDetected = this._onDetected.bind(this);
  }
  componentDidMount() {
    this._checkAttandance();
    this._getAllMyTicket();
    this._getMyStockSammary();
    this._getWorkOrder();
    this.checkTime();
    console.log('render')  
    
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.results !== this.state.results) {
      this.setState({
        barCode: this.state.results.length > 0 ? this.state.results[this.state.results.length - 1].codeResult.code : "",
        loader:'',
      })
    }
  }
  checkTime() {
    let current_time = moment.tz(moment(), 'Asia/Kolkata').format("HH:mm");
    let Day = moment.tz(moment(), 'Asia/Kolkata').format('dddd');

    current_time = current_time.replace(/:/g, '.')
    console.log(current_time);
    if(current_time>9) {
      this.setState({
        showHideAttendanceBtn: true
      })

    }
  }
  async _checkAttandance() {
    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      console.log('decoded');
      console.log(decoded);
      sro_id = decoded.warehouse_id;
    }
    var requestType = "CheckAttendance";
    await axios.get(config.get('API_URL') + '/inventory/SRO-API?sroid=' + sro_id + '&requestType=' + requestType, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      console.log('check Attandance');
      console.log(response);
      console.log(response.data.status);
      if (response.data.status === "Success CheckAttendance") {
        this.setState({
          showHideAttendanceBtn: true,
          showHideOtherBtn: false,
        });
      } else {
          this.setState({
                showHideOtherBtn: true
          })
        let current_time = moment.tz(moment(), 'Asia/Kolkata').format("HH:mm");
        let Day = moment.tz(moment(), 'Asia/Kolkata').format('dddd');

        current_time = current_time.replace(/:/g, '.')
        console.log(current_time);
        if(current_time>9) {
          this.setState({
            showHideAttendanceBtn: true
          })

        } else {
            this.setState({
              showHideAttendanceBtn: false,

            });
        }
      }
      this.setState({
        checkAttandance: response.data,
      })
    }).catch(error => {
      console.log('Failed SRO Check attandance');
      console.log(error);
      this.checkTime();
    });

  }
async _markAttandance() {
    let current_time = moment.tz(moment(), 'Asia/Kolkata').format("HH:mm");
    let Day = moment.tz(moment(), 'Asia/Kolkata').format('dddd');
    current_time = current_time.replace(/:/g, '.')
    if(current_time>9) {
      this.setState({
        showHideAttendanceBtn: true
      })
      this.props.handleClick("tr", 3, "You cannot mark Attendance after 9 AM.");
      return false;
    }

    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      sro_id = decoded.warehouse_id
    }
    var requestType = "MarkAttendance";
    await axios.get(config.get('API_URL') + '/inventory/SRO-API?sroid=' + sro_id + '&requestType=' + requestType, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      console.log('marks Attandance');
      console.log(response);
      if (response.data.status === "Attendance already marked" || response.data.status === "Success MarkAttendance") {
        this.setState({
          showHideAttendanceBtn: true,
          showHideOtherBtn: false,
        });
      } else {
        this.props.handleClick("tr", 3, response.data.status);
        this.setState({
          showHideAttendanceBtn: false,
          showHideOtherBtn: true,
        });
      }
    }).catch(error => {
      console.log('Failed SRO mark attandance');
      console.log(error);
    });
  }
  async _getAllMyTicket() {
    var Mobile = "";
    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      console.log('decoded');
      console.log(decoded);
      Mobile = decoded.phone;
    }
    var body = {
      SroMobile: Mobile,
      token: "bymfqp123"
    }
    await axios.post(config.get('API_URL') + '/inventory/fd_getAllTicket',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      console.log('All Tickets');
      console.log(response);

      var openTickets = response.data.response.filter(function(Tdata){
        return Tdata.status === "open" && Tdata.issueSubCategory !== "Inventory Check and Maintenance"
      });

      //Filter only open ICM Tickets
      var openICMtickets = response.data.response.filter(function(Tdata){
        return Tdata.status ==="open" && Tdata.issueSubCategory === "Inventory Check and Maintenance"
      }); 

      //Segregating the tickets having same parent Ticket and grouping
      const groupedICMs = openICMtickets.reduce((acc, d) => {
        if (Object.keys(acc).includes(d.parentId)) return acc;
        acc[d.parentId] = openICMtickets.filter(g => g.parentId === d.parentId); 
        return acc;
      }, {})
      
      console.log("groupedICM Tickets");
      console.log(groupedICMs);
      var parentTicketArr = Object.keys(groupedICMs);
      console.log(parentTicketArr);

      var childTicketsWithParent = [];
      for(let i=0;i<parentTicketArr.length;i++){
        const tempData = groupedICMs[parentTicketArr[i]];
        childTicketsWithParent.push(tempData);
      }
      console.log(childTicketsWithParent);

      var CloseTickets = response.data.response.filter(function (Tdata) {
        return Tdata.status === "resolved";
      });
      
      
      this.setState({
        childTicketsWithParent:   childTicketsWithParent,
        onlyICMTcketData:         openICMtickets,
        myTicketData:             openTickets,
        MyCloseTicketData:        CloseTickets,
        icmParentIDs:             parentTicketArr,
        totalMyTicketOpenCount:   (openTickets.length || 0),
        totalMyTicketCloseCount:  (CloseTickets.length || 0),
        totalICMtcikets:          (openICMtickets.length || 0),
        //myRetrievalTicket:response.data.
        issueSubCategory: "Application Upgrade",
        loader:'none',
      });
      console.log("Open Tickets Expet ICM");
      console.log(this.state.myTicketData);
      console.log("only ICM Tickets0");
      console.log(this.state.onlyICMTcketData);
    }).catch(error => {
      console.log('Ticket Error');
      console.log(error);
    });
  }
  async _getMyStockSammary() {
    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      sro_id = decoded.warehouse_id
      console.log
      (decoded);
    }
    console.log('stock summary start');
    var requestType = "StockDetails";
    await axios.get(config.get('API_URL') + '/inventory/SRO-API?sroid=' + sro_id + '&requestType=' + requestType, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      console.log('SRO stock summary');
      console.log(response);
      this.setState({
        myStockSummary: response.data.stockdata,
      })
    }).catch(error => {
      console.log('Failed SRO stock summary');
      console.log(error);
    });
  }
  async _getWorkOrder() {
    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      sro_id = decoded.warehouse_id
    }
    var requestType = "OrderDetails";
    await axios.get(config.get('API_URL') + '/inventory/SRO-API?sroid=' + sro_id + '&requestType=' + requestType, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      console.log('Work Order');
      console.log(response);
      var collectWorkOrder = response.data.orderdata.filter(function (Tdata) {
        return Tdata.ordertype === "WO";
      });
      var returnWorkOrder = response.data.orderdata.filter(function (Tdata) {
        return Tdata.ordertype === "RO";
      });
      this.setState({
        collectWorkOrder: (collectWorkOrder || []),
        returnWorkOrder: (returnWorkOrder || [])
      })
    }).catch(error => {
      console.log('Failed work order');
      console.log(error);
    });
  }
  //TerminalRetrieval success flow
  async _TerminalRetrieval() {
  console.log("Terminal Retrieval Calling");
  if(this.state.terminalStatus==="Terminal Available") {
  //alert(this.state.barCode);
   if(this.state.barCode=="" || this.state.barCode5==""){
        this.props.handleClick("tr", 3, "Please Enter Sim Serial Number");
        return false;
    }
    if(this.state.barCode=="" || this.state.barCode2==""){
        this.props.handleClick("tr", 3, "Please Enter Sim Serial Number");
        return false;
    }
  if(this.state.barCode!=this.state.barCode){
        this.props.handleClick("tr", 3, "Please Enter Terminal Serial No.");
        return false;
    }
 /* if(this.state.barCode!=this.state.barCode3){
       this.props.handleClick("tr", 3, "Terminal Matched");
        this.setState({
                    barCode3:this.state.barCode
                })
        return false;
    } */
    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      sro_id = decoded.warehouse_id
    }
  var requestType = "TerminalRetrieval";
  //alert(this.state.terminalStatus);
  var postdata = {
      scan_detais:this.state.scanDetails,
      sro_id:sro_id,
      barCode:this.state.barCode
  }
    await axios.post(config.get('API_URL') + '/inventory/scan-terminal', postdata, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` ${localStorage.usertoken}`,
      SalesforceToken: ` ${localStorage.salesforce_token}`
    }
  }).then(response => {
    console.log('TerminalRetrieval');
    console.log(response);
    this.setState({
        barCode:"",
        barCode1:""
    })
    if (response.data.status === "TerminalMatched") {
      this.props.handleClick("tr", 1, response.data.reason);
      this.setState({
        scanmodalIssue:false
      })
    } else if (response.data.status === "TerminalnotMatched") {
      this.props.handleClick("tr", 3, response.data.reason);
      this.setState({
        scanmodalIssue:false
      })
    }
    else if (response.data.status === "Failure") {
      this.props.handleClick("tr", 3, response.data.reason);
      //this.props.handleClick("tr", 3, response.data.reason);
      this.setState({
        scanmodalIssue:false
      })
      this.resolveTicket();
    }
    else {
       if(response.data.reason==null || response.data.reason==''|| response.data.reason=="null")
       {
       this.props.handleClick("tr", 3, "Terminal Already Retrieved");
       } else {
       this.props.handleClick("tr", 3, response.data.reason);
       }
         this.setState({
        scanmodalIssue:false
        })
      }
  }).catch(error => {
    console.log('Failed SRO Check Terminal Retrieval');
    console.log(error);
   });
  } else {
   if(this.state.store_manager_number=="" || this.state.store_manager_name==""){
        this.props.handleClick("tr", 3, "Please Enter Store Manager Name & Number");
        return false;
   }
   if(this.state.store_manager_number.length!=10){
        this.props.handleClick("tr", 3, "Please Enter Correct Number");
        return false;
   }
    this.resolveTicket();
  } }


  //no longer required
  async _validateSerialNo() {
    this.setState({
      validate_msg: "",
      barCode3: ""
    })
    //alert(this.state.barCode);
    if (this.state.barCode == "" || this.state.barCode1 == "") {
      this.props.handleClick("tr", 3, "Please Enter Terminal Serial No");
      return false;
    }
    if (this.state.barCode != this.state.barCode1) {
      this.props.handleClick("tr", 3, "Terminal Serial No. are not matched");
      return false;
    }
    const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      sro_id = decoded.warehouse_id
    }
    var requestType = "TerminalRetrieval";
    //alert(this.state.terminalStatus);
    var postdata = {
      scan_detais: this.state.scanDetails,
      sro_id: sro_id,
      barCode: this.state.barCode
    }
    await axios.post(config.get('API_URL') + '/inventory/getvalidate', postdata, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      confirmAlert({
        title: 'Alert',
        message: response.data.reason, // stockdata, status, reason, pincode, orderdata, iskuAssetItem
        buttons: [{
            label: 'OK',
            //onClick: () => {
            //    this.transactionReportDownload();
            //}
          },
          {
            label: 'Cancel',
            onClick: () => {
              this._onclickmyScanModel("", "", "", "", "", "");
            },
          }
        ]
      });
      console.log(response.data.status);
      if (response.data.status == 'TerminalMatched' || response.data.status == 'TerminalNotMatched') {
        this.setState({
          barCode3: this.state.barCode
        })
  
      }
      this.setState({
        validate_msg: response.data.reason
      })
  
    }).catch(error => {
      console.log('Failed');
      console.log(error);
    });
  }


async resolveTicket(){
   var body = {
        ticket_id: this.state.ticket_id,
        store_manager_name: this.state.store_manager_name,
        store_manager_number: this.state.store_manager_number
    }
    console.log(body);
   await axios.post(config.get('API_URL') + '/inventory/resolveticket',
      body, {
       headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
    console.log(response.data.status);
    this.setState({
                                scanmodalIssue:false
      })
      }).catch(error => {
    console.log(error);
   });
  }
  /* axios({
  method: 'post',
  url: 'https://innovitiservice.freshdesk.com/api/v2/tickets/647523/notes',
  headers: {"Authorization : Basic S2JvMll0V25nYlNialJnNWFyaTo=", "Content-Type : application/json"},
  data: {
    "body" : "test"
  }
});
} */
  _onclickModalmyTickets(priority, ticketId, utid, store, storeAddress, issueSubCategory, dispatcherDate, dispatcherSource, issueType, dispatchTime, iskuName, iskuDesc, merchantContactNumber, cfRetrievalTSN, proactiveChecks) {
    let tempticketDetails = {
      priority: priority,
      ticketId: ticketId,
      utid: utid,
      store: store,
      storeAddress: storeAddress,
      issueSubCategory: issueSubCategory,
      dispatcherDate: dispatcherDate,
      dispatcherSource: dispatcherSource,
      issueType: issueType,
      dispatchTime: dispatchTime,
      iskuName: iskuName,
      iskuDesc: iskuDesc,
      merchantContactNumber: merchantContactNumber,
      cfRetrievalTSN: cfRetrievalTSN,
      proactiveChecks: proactiveChecks
    };
    this.setState({
      ticketDetails: tempticketDetails,
      store_code: utid,
      modalIssue: this.state.modalIssue === true ? false : true,
    })
  }
  _onclickModalmyTickets1(ticketId, utid, store) {

    /* let tempticketDetails = {
    }; */
    this.setState({
      ticketId1: ticketId,
      utid1: utid,
      //ticketDetails: tempticketDetails,
      modalIssue1: this.state.modalIssue1 === true ? false : true,
    })
  }
  _onclickModalmyTickets2(ticketId, utid, store) {
    /* let tempticketDetails = {
    }; */
    this.setState({
      //ticketDetails: tempticketDetails,
      modalIssue2: this.state.modalIssue2 === true ? false : true,
    })
  }
  _onclickModalmyTickets3(){
    this.setState({
        modalIssue1: false
    })
  }
  _onclickModaluploadfile(ticketId, utid, store) {

    /* let tempticketDetails = {
    }; */
    this.setState({
      ticketId1: ticketId,
      utid1: utid,
      //ticketDetails: tempticketDetails,
      modalIssue1: this.state.modalIssue1 === true ? false : true,
    })
  }

  _refreshPage() {
    this._appendLoaderToBody();
    window.location.reload();
  }
  _getLocation() {
    this.props.handleClick("tr", 1, "Geo location saved successfully");
    this.setState({
        modalIssue1: false
    })
    let SuccesMsg = "";
    let ticketId = this.state.ticketId1;
    let utid = this.state.utid1;
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var lat = position.coords.latitude;
        var lang = position.coords.longitude

        var body = {
          ticketid: ticketId,
          utid: utid,
          lattitude: lat.toString(),
          longitude: lang.toString()
        }
        console.log('request body');

        console.log(body);
        axios.post(config.get('API_URL') + '/inventory/fd_SendSROGeoLocation',
          body, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: ` ${localStorage.usertoken}`,
              SalesforceToken: ` ${localStorage.salesforce_token}`
            }
          }).then(response => {
            this.setState({
                modalIssue1: false
            })
          console.log('Success send geo location');

//           console.log(response.data.Message);
//           SuccesMsg = response.data.Message;
        }).catch(error => {

          console.log('Error in send sro geo location');
          console.log(error);
        });
      },

      function errorCallback(error) {
        console.log('geo location finding error');
        console.log(error);
      },
      {
        timeout: 5000
      }
    );
    console.log(SuccesMsg);
    if (SuccesMsg !== "") {
      this.props.handleClick("tr", 2, SuccesMsg);
    }
  }
  _scan() {
    this.setState({scanning: !this.state.scanning});
  }
  _onDetected(result) {
    this.setState({results: this.state.results.concat([result])});
  }
  _barcodeChanege(tempBarcode) {
    //console.log('hhh');
    console.log(tempBarcode);
    this.setState({
      barCode: tempBarcode
    })
  }
  _barcodeChanege1(tempBarcode) {
    //console.log('hhh');
    console.log(tempBarcode);
    this.setState({
      barCode1: tempBarcode
    })
  }
  _barcodeChanege4(tempBarcode) {
    //console.log('hhh');
    console.log(tempBarcode);
    this.setState({
      barCode1: tempBarcode
    })
  }
  _nameChange(name) {
    this.setState({
      store_manager_name: name
    })
  }
 _numberChange(phoneNo) {
   this.setState({
      store_manager_number: phoneNo
    })
  }
  _getAllDevices() {
    axios.get(config.get('API_URL') + '/reports/binaryApp-get-all-devices/', {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      }
    }).then(response => {
      console.log('device data');
      console.log(response);
      var tempList = [];
      (response.data.data || []).map(d => {
        tempList.push({value: d.device_name, label: d.device_name})
      });
      this.setState({
        deviceList: (tempList || []),
        addDeviceList: (tempList || []),
      })
    }).catch(error => {
      console.log('Error get device');
      console.log(error);
    });
  }
  _getAllProducts() {
    axios.get(config.get('API_URL') + '/reports/binaryApp-get-all-products/', {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      }
    }).then(response => {
      console.log('product data');
      console.log(response);
      var tempList = [];
      (response.data.data || []).map(d => {
        tempList.push({value: d.product_name, label: d.product_name})
      });
      this.setState({
        productList: (tempList || []),
        addProductList: (tempList || []),
      })
    }).catch(error => {
      console.log('Error get product');
      console.log(error);
    });
  }
  _getAllVersion() {
    let reqBody = {
      product_name: (this.state.productIds[this.state.productIds.length - 1] || '')
    }
    axios.post(config.get('API_URL') + '/reports/binaryApp-get-all-version/', reqBody, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      },
    }).then(response => {
      console.log('version data');
      console.log(response);
      var tempList = [];
      (response.data.data || []).map(d => {
        tempList.push({value: d.bin_version, label: d.bin_version})
      });
      this.setState({versionList: (tempList || [])})
    }).catch(error => {
      console.log('Error get version');
      console.log(error);
    });
  }
  _onDeviceChange(optionSelected) {
    let value = '';
    let deviceArray = [];
    if (optionSelected.length < 1) {
      value = null;
      deviceArray = '';
    } else {
      optionSelected.map((ids, i) => {
        deviceArray.push(ids.value)
        var index = this.state.deviceList.findIndex(obj => obj.value === ids.value);
        this.state.deviceList.move(index, 0).join(',');
      });
    }
    this.setState({
      deviceIds: deviceArray,
      deviceValues: optionSelected
    });
  }
  _onProductChange(optionSelected) {
    let value = '';
    let productArray = [];
    if (optionSelected.length < 1) {
      value = null;
      productArray = '';
    } else {
      optionSelected.map((ids, i) => {
        productArray.push(ids.value)
        var index = this.state.productList.findIndex(obj => obj.value === ids.value);
        this.state.productList.move(index, 0).join(',');
      });
    }
    this.setState({
      productIds: productArray,
      productValues: optionSelected
    });
    setTimeout(function () {
      this._getAllVersion();
    }.bind(this), 5000);
  }
  _onVersionChange(optionSelected) {
    let value = '';
    let versionArray = [];
    if (optionSelected.length < 1) {
      value = null;
      versionArray = '';
    } else {
      optionSelected.map((ids, i) => {
        versionArray.push(ids.value)
        var index = this.state.versionList.findIndex(obj => obj.value === ids.value);
        this.state.versionList.move(index, 0).join(',');
      });
    }
    this.setState({
      versionIds: versionArray,
      versionValues: optionSelected
    });
  }
  getBinaryAppDetails() {
    var that = this;
    var postData = {
      device_name: this.state.deviceIds,
      product_name: this.state.productIds,
      bin_version: this.state.versionIds
    };
    if ($.fn.DataTable.isDataTable('#tblBinaryAppDetails')) {
      $('#tblBinaryAppDetails').DataTable().clear().destroy();
    }
    var binaryDetailsTable = $('#tblBinaryAppDetails').DataTable(
      {
        order: [],
        "processing": true,
        "serverSide": true,
        "bDestroy": true,
        "paging": true,
        "pageLength": 20,
        "bInfo": false,
        "sPaginationType": "numbers",
        //"autoWidth": false,
        "responsive": false,
        "scrollX": true,
        "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],
        ajax: {
          url: config.get('API_URL') + "/reports/binaryApp-get-details-for-SRO/",
          type: "POST",
          data: postData,
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", localStorage.usertoken);
          },
        },
        columns: [
          {"data": "Device"},
          {"data": "Product"},
          {"data": "Version"},
          {"data": "releasedate"},
          {"data": "fileName"},
        ],
        "columnDefs": [
          {
            render: function (data) {
              var strArray = data.split("$$");
              var fileName = (strArray[0] || '');
              return '<td ><a href="#" data-tip="Download" data-id="' + fileName + '" class="btn btn-default actionBtn btn-edit">' +
                '<span class="glyphicon glyphicon-download" aria-hidden="true"></span></a>&nbsp;     ' +
                '</td>';
            },
            // "width": "80px",
            "targets": 4,
            className: "action_button",
          },
        ],
      });
    $('#tblBinaryAppDetails').on('click', 'td.action_button a', function (e) {
      e.stopImmediatePropagation();
      var fileName = $(this).data("id");
      that.binary_file_download(fileName);
    })
  }
  _fetchRecordByFilter() {
    this.getBinaryAppDetails();
  }
  _removeFilter() {
    this.setState({
      deviceValues: [],
      deviceIds: [],
      productValues: [],
      productIds: [],
      versionValues: [],
      versionIds: [],
    });
    this.getBinaryAppDetails();
  }
  binary_file_download(lFileName) {
    const token = localStorage.usertoken;
    let userName = '';
    let mobile='';
    if (token != null) {
      const decoded = jwt_decode(token);
      console.log('decoded');
      console.log(decoded);
      mobile=decoded.phone;
      userName = decoded.firstName +' '+decoded.lastName;
    }
    let vType = '';
    let vExt = '';
    if (lFileName.includes('.xlsx') || lFileName.includes('.xls')) {
      vType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;";
      vExt = 'xlsx';
    } else if (lFileName.includes('.csv')) {
      vType = "application/csv";
      vExt = 'csv';
    }
    this.setState({
      is_download: false,
      model_visible: true,
      file_url: '',
      rfile: ''
    });
    var postData = {
      fileName: lFileName,
      download: 1,
      down_phn_no : mobile,
      down_user_name : userName
    };
    let xhrBank = $.ajax({
      url: config.get('API_URL') + "/reports/binaryApp-download-file",
      type: "POST",
      data: postData,
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", localStorage.usertoken);
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function (response, status, xhr) {
        let blob = new Blob([response], {
          type: vType
        });
        let fileName = timestamp + 'binary' + '.' + vExt;
        let rfile = fileName.replace(/\"/g, "");
        let url = window.URL.createObjectURL(blob);
        this.setState({
          is_download: true,
          file_url: url,
          rfile: rfile
        })
      }.bind(this)
    });
    this.setState({
      xhrBank: xhrBank
    })
  }
  downloadFile(e) { //alert(this.state.file_url);
    let a = document.createElement('a');
    a.href = this.state.file_url;
    a.download = this.state.rfile;
    a.click();
    window.URL.revokeObjectURL(this.state.file_url);
  }
  closeModal() {
    this.setState({
      model_visible: false
    });
  }
  bindBinaryTable() {
    this._getAllDevices();
    this._getAllProducts();
    this._getAllVersion();
    this.getBinaryAppDetails();
  }
_onclickmyScanModel(utid,issueSubCategory, issueType , cfRetrievalTSN, terminalStatus, ticketId) {

    if(terminalStatus==='Terminal Available') {
       this.setState({
            store_manager_name:"",
            store_manager_number:""
       })
    }
    let scanticketDetails = {
      utid: utid,
      issueSubCategory: issueSubCategory,
      issueType: issueType,

      cfRetrievalTSN: cfRetrievalTSN,
      ticket_id:ticketId,

    };
    this.setState({
      scanDetails: scanticketDetails,
      terminalStatus: terminalStatus,
      scanmodalIssue: this.state.scanmodalIssue === true ? false : true,
       ticket_id:ticketId
    })
  }
  async terminalSta(){
     const token = localStorage.usertoken;
    let sro_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      sro_id = decoded.warehouse_id
    }
    var postdata = {
      scan_detais:this.state.scanDetails,
      sro_id:sro_id,
      barCode:this.state.barCode
  }
    await axios.post(config.get('API_URL') + '/inventory/postretrieval', postdata, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` ${localStorage.usertoken}`,
      SalesforceToken: ` ${localStorage.salesforce_token}`
    }
  }).then(response => {
    console.log('UnknownTerminalRetrieval');
    console.log(response);
    this.setState({
        barCode:"",
        barCode1:""
    })
    if (response.data.status === "Success") {
      this.props.handleClick("tr", 1, "Terminal is found in inventory. Your stock will get Updated");
      this.setState({
        scanmodalIssue:false
      })
    } else if(response.data.status === "Failure") {
   this.props.handleClick("tr", 3, "Terminal not found");
    this.setState({
    scanmodalIssue:false
    })
      }else{
      }
  }).catch(error => {
    console.log('Failed SRO Check Terminal Retrieval');
    this.props.handleClick("tr", 3, "Internal Error! Something went wrong.");
    console.log(error);
   });
  }
  checkDamage(val){
    this.setState({
        is_damage: val
    })
  }
   fileChangedHandler = event => {
//       const file = event.target.files[0];
//       this.setState({ selectedFile: event.target.files[0] });
//       alert(event.target.files[0].val);
    }

  changeAdapter(val){
    this.setState({
      adapter:val
    })
  }
  changeUsb(val){
    this.setState({
      usb:val
    })
  }
    _serialChange(val) {
       this.setState({
        sim_serial:val
       })
    }
    _reSerialChange(val) {
         this.setState({
          sim_re_serial:val
       })
    }
fileChangedHandler = event => {
//       const file = event.target.files[0];
      this.setState({ selectedFile: event.target.files[0]});
      this.setState({ selectedFileName: event.target.files[0].name});
      this.setState({ selectedFileExtension: event.target.files[0].type});

//       alert(event.target.files[0].val);
    }
    

  
    //on submit retrieval



  async _onSubmitDetails() {
    if (this.state.terminalStatus === 'Terminal Not Available') {
      console.log("Terminal Not Available");
      var body = {
        store_manager_name: this.state.store_manager_name,
        store_manager_number: this.state.store_manager_number,
        status: 4,
        ticket_id: this.state.ticket_id,
        token: "bymfqp123"
      }
      await axios.post(config.get('API_URL') + '/inventory/resolve-ticket',
        body, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ` ${localStorage.usertoken}`,
            SalesforceToken: ` ${localStorage.salesforce_token}`
          }
        }).then(response => {
        console.log('Resolved');
        console.log(response);
      }).catch(error => {
        console.log('Ticket Error');
        console.log(error);
      });
      this.setState({
        scanmodalIssue: false
      });
  
    } else {
      // Upload Image Start
      const reader = new FileReader();
      const ticket_id = this.state.ticket_id;
      const filename = this.state.selectedFileName;
      const file_extension = this.state.selectedFileExtension;
      reader.addEventListener("load", function() {
        var base64 = reader.result;
        console.log("Base 64");
        console.log(base64);
        var body = {
          attachment: base64,
          ticket_id: ticket_id,
          upload_type: "Terminal Damaged",
          filename: filename,
          file_extension: file_extension,
          token: "bymfqp123"
        }
        axios.post(config.get('API_URL') + '/inventory/upload-image',
          body, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: ` ${localStorage.usertoken}`,
              SalesforceToken: ` ${localStorage.salesforce_token}`
            }
          }).then(response => {
          console.log('Resolved');
          console.log(response);
        }).catch(error => {
          console.log('Ticket Error');
          console.log(error);
        });
      }, false);
      if (this.state.selectedFile) {
        reader.readAsDataURL(this.state.selectedFile);
      }
      // Upload Image END
      const token = localStorage.usertoken;
      let sro_id = '';
      if (token != null) {
        const decoded = jwt_decode(token);
        sro_id = decoded.warehouse_id
      }
      var postdata = {
        scan_detais: this.state.scanDetails,
        sro_id: sro_id,
        barCode: this.state.barCode,
        adapter: this.state.adapter,
        usb: this.state.usb,
        sim_serial: this.state.sim_serial
      }
      await axios.post(config.get('API_URL') + '/inventory/postretrieval', postdata, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
        console.log('UnknownTerminalRetrieval');
        console.log(response);
        this.setState({
          barCode: "",
          adapter: "",
          usb: "",
          sim_serial: "",
          sim_re_serial: "",
          barCode3: "",
          scanmodalIssue: false,
          barCode1: ""
        });
        var body = {
          status: 4,
          ticket_id: this.state.ticket_id,
          token: "bymfqp123"
        }
  
        axios.post(config.get('API_URL') + '/inventory/resolve-ticket2',
          body, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: ` ${localStorage.usertoken}`,
              SalesforceToken: ` ${localStorage.salesforce_token}`
            }
          }).then(response => {
          console.log('Resolved');
          console.log(response);
        }).catch(error => {
          console.log('Ticket Error');
          console.log(error);
        });
        if (response.statusText === "OK") {
          console.log("Postretrieval Success");
          this.props.handleClick("tr", 1, "Terminal is found in inventory. Your stock will get Updated");
          this.setState({
            scanmodalIssue: false
  
          });
        } else {
          console.log("Postretrival Failure");
          this.props.handleClick("tr", 3, "Terminal not found");
          this.setState({
            scanmodalIssue: false
          })
        }
      }).catch(error => {
        console.log('Failed SRO Check Terminal Retrieval');
        this.props.handleClick("tr", 3, "Internal Error! Something went wrong");
        console.log(error);
      });
    }
  }

async reduce_image_file_size(base64Str, MAX_WIDTH = 1080, MAX_HEIGHT = 720) {
  let resized_base64 = await new Promise((resolve) => {
      let img = new Image()
      img.src = base64Str
      img.onload = () => {
          let canvas = document.createElement('canvas')
          let width = img.width
          let height = img.height

          if (width > height) {
              if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width
                  width = MAX_WIDTH
              }
          } else {
              if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height
                  height = MAX_HEIGHT
              }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL()) // this will return base64 image results after resize
      }
  });
  return resized_base64;
}


jobSheetChangedHandler = event => {
  this.setState({ selectedJobSheetFile: event.target.files[0]});
  this.setState({ selectedJobSheetFileName: event.target.files[0].name});
  this.setState({ selectedJobSheetFileExtension: 'image/png'});//event.target.files[0].type

  let file = event.target.files[0];
  //converting image to Base64 String
  this.getBase64(file).then(result => {
        file["base64"] = result;
        //reducing image size
        this.reduce_image_file_size(result).then(newImage=>{
          console.log(newImage);
          this.setState({
            base64URL: newImage,
            file
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
}

getBase64 = file => {
    return new Promise(resolve => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object

        baseURL = reader.result;
        console.log(baseURL);
        resolve(baseURL);
      };
      console.log(fileInfo);
    });
  };

async uploadJobSheet(){
  this._appendLoaderToBody();
  const reader = new FileReader();
  const ticket_id = this.state.ticketId1;
  const filename = this.state.selectedJobSheetFileName;
  const file_extension = this.state.selectedJobSheetFileExtension;

      var body = {
        attachment : this.state.base64URL,
        ticket_id : ticket_id,
        upload_type: "Upload Jobsheet",
        filename : filename,
        file_extension : file_extension,
        token: "bymfqp123"
      }

      console.log(body);
      axios.post(config.get('API_URL') + '/inventory/upload-image',
        body, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ` ${localStorage.usertoken}`,
            SalesforceToken: ` ${localStorage.salesforce_token}`
          }
        }).then(response => {

          //New---> it does not effect previous feature
          if(response.data.status){
            if(this.state.uploadButtonId!==''){
              var jobSheetInfo = {
                uploadButtonId:this.state.uploadButtonId,
                invCheckButtonId: this.state.ticketId1
              };
  
              let localTicketInfo = JSON.parse(window.localStorage.getItem('uploaded_job_sheet'));
              console.log(localTicketInfo);
  
              if(localTicketInfo === null){
                console.log("Local Tickets Null");
                localTicketInfo = [];
                localTicketInfo.push(jobSheetInfo);
                window.localStorage.setItem('uploaded_job_sheet',JSON.stringify(localTicketInfo));
                console.log(localTicketInfo);
                this.setState({
                  jobSheetData:localTicketInfo,
                  uploadButtonId:'',
                  loader:'none'
                });
              }else{
                console.log("Creating new local Ticket data");
                localTicketInfo.push(jobSheetInfo);
                window.localStorage.setItem('uploaded_job_sheet',JSON.stringify(localTicketInfo));
                console.log(localTicketInfo);
                this.setState({
                  jobSheetData:localTicketInfo,
                  uploadButtonId:'',
                  loader:'none'
                });
              }
            }
            alert("Your Job sheet uploaded.");
            console.log('Resolved');
            console.log(response);
          }else{
            alert("Job sheet upload failed due to File size is large or network issue.");
          }

      }).catch(error => {
        console.log('Ticket Error');
        alert("Opps! Something went wrong.");
        this.setState({
          loader:'none',
        })
        console.log(error);
      });

      this._getLocation()

}
 _sendStoreLocation() {

    let that = this;
    let SuccesMsg = "";
    let ticketId = this.state.ticketId1;
    let utid = this.state.utid1;
    let store_code = this.state.store_code;
        store_code = store_code.substring(0,6);

//     console.log(store_code);
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var lat = position.coords.latitude;
        var lang = position.coords.longitude

        var body = {
          storeCode: store_code,
          lat: lat,
          lon: lang
        }
//         console.log('request body');

        console.log(body);
        axios.post(config.get('API_URL') + '/inventory/send_store_location',
          body, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: ` ${localStorage.usertoken}`,
              SalesforceToken: ` ${localStorage.salesforce_token}`
            }
          }).then(response => {
//              console.log(response.data.message)
//              console.log('Success send geo location');
             that.props.handleClick("tr", 1, response.data.message);
             that.setState({
                modalIssue: false
             })
        }).catch(error => {

          console.log('Error in send sro geo location');
          console.log(error);
        });
      },

      function errorCallback(error) {
        console.log('geo location finding error');
        console.log(error);
      },
      {
        timeout: 5000
      }
    );
    console.log(SuccesMsg);
    if (SuccesMsg !== "") {
      this.props.handleClick("tr", 2, SuccesMsg);
    }
  }

  //------------------------------------------------------------------------------------------
  
  /*
    JIRA Ticket-  https://pmoinnoviti.atlassian.net/jira/software/projects/BBO/boards/127?assignee=61920d3cfe9f300068c51503&selectedIssue=BBO-185
    Author-       sabir.ansari@innoviti.com
  */


  //Initializing store image upload for KYC
  _getKYCData(icmTicketId, anyStoreUtId){
    this._checkPermissions();
    const isMobile = window.matchMedia("(min-width: 768px)").matches;
    this.setState({
      invCheckImgUpload:true,
      storeImageData:{
        ticket_id:icmTicketId,
        utid:anyStoreUtId,
        isMobile:isMobile,
      }
    });
  }


  //Initializing Media Devices
  _initializeMedia = async () => {
    this.setState({ 
        imageDataURL: null,
        captureButton:'',
        finalUploadButton:'none',
        cameraSwitchButton:'',
        cameraResetButton:'none',
    });
    this._getGeoLocation();

    if(this.state.openCamera){

      if (!("mediaDevices" in navigator)) {
        navigator.mediaDevices = {};
      }
      
      //Get the details of video inputs of the device
      const videoInputs = await this._getListOfVideoInputs();

      //The device has a camera and GSP is Enabled
      if (videoInputs.length && this.state.GPSPermission) {
        navigator.mediaDevices.getUserMedia({

          video: {
              width: 1280,
              height: 720,
              deviceId: {
              exact: videoInputs[this.cameraNumber].deviceId,
              },
          },

        }).then((stream) => {

          this.player.srcObject = stream;
          console.log(this.player.srcObject);
          
          this.setState({
            captureImageButton:{
              disabled:false
            },
          });
        }).catch((error) => {
          console.error(error);
        });

      }else if(videoInputs.length && !this.state.GPSPermission){
        this._closeinvCheckImgUpload();
        alert("Reset GPS access permissions or Open in different Brower. Make sure you grant all asked permissions.");
      
      }else{
        this._closeinvCheckImgUpload();
        alert("Device has no camera or permission is denied.");
      }
    }else{
      this._closeinvCheckImgUpload();
      alert(" Camera access permission denied. Try Reloading the page.");
    }
  };


  //check media permissions
  _checkPermissions(){
    var constraints = { audio: true, video: { width: 1280, height: 720}};
    var that = this;

    navigator.permissions.query({name:'camera'}).then(function(result) {
      if (result.state === 'granted') {
        //permission has already been granted, no prompt is shown
        that.setState({
          openCamera:true
        });
        that._initializeMedia();
      }else if (result.state === 'prompt') {
        var successCallback = function() {
          // user allowed access to camera
          that.setState({
            openCamera:true
          });
          that._initializeMedia();
        };
        var errorCallback = function(error) {
          if (error.name === 'NotAllowedError') {
            that._closeinvCheckImgUpload();
            alert("Camera Access is denied, Please reset permissions or open in a different Browser.");
          }
        };

        if(that.state.GPSPermission){
          navigator.mediaDevices.getUserMedia(constraints).then(successCallback, errorCallback);
        }

      }else if (result.state === 'denied') {
        that._closeinvCheckImgUpload();
        alert("Permission Blocked, Please reset permissions or open in a different Browser.");
      }
    });
  }


  //get Geo Location
  _getGeoLocation = () =>{
    var that = this;
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var lat = position.coords.latitude;
        var long = position.coords.longitude;
        that.setState({
          storeLocation:{
            lat:  lat,
            long: long,
          },
          GPSPermission:  true,
        })
        console.log(that.state.storeLocation);
      },
      function errorCallback(error) {
        that.setState({
          GPSPermission: false,
        });
        that._closeinvCheckImgUpload();
      }
    );
  }


  //Capture Image
  _capturePicture = () => {
    var canvas = document.createElement("canvas");
    canvas.width = this.player.videoWidth;
    canvas.height = this.player.videoHeight;
    var contex = canvas.getContext("2d");
    contex.drawImage(this.player, 0, 0, canvas.width, canvas.height);
    this.player.srcObject.getVideoTracks().forEach((track) => {
        track.stop();
    });
    console.log("Image Before Resizing");
    console.log(canvas.toDataURL());
    const imageBeforeRe = canvas.toDataURL();
    //reducing the image size
    this.reduce_image_file_size(imageBeforeRe).then(newImage=>{
      
      console.log("Image after Resizing");
      console.log(newImage)
      this.setState({ 
        imageDataURL: newImage,
        finalUploadButton:'',
        captureButton:'none',
        uploadingButtonMessage:'',
        uploadButtonName:'pe-7s-stopwatch',
        uploadImageButton:{
          disabled:true,
        },
        cameraResetButton:'',
        cameraSwitchButton:'none',
      });
    })

    //wait to 3 sec to load Lat long of the device
    setTimeout(()=>{
        this.setState({
          uploadImageButton:{
            disabled:false
          },
          uploadButtonName:'pe-7s-cloud-upload',
        })
    },2500);
  };


  //switch Camera Rear or Front camera
  _switchCamera = async () => {
    const listOfVideoInputs = await this._getListOfVideoInputs();

    // The device has more than one camera
    if (listOfVideoInputs.length > 1) {
        if (this.player.srcObject) {
            this.player.srcObject.getVideoTracks().forEach((track) => {
            track.stop();
          });
        }
        // switch to second camera
        if (this.cameraNumber === 0) {
            this.cameraNumber = 1;
        }
        // switch to first camera
        else if (this.cameraNumber === 1) {
            this.cameraNumber = 0;
        }
        // Restart based on camera input
        this._initializeMedia();
    }else if (listOfVideoInputs.length === 1) {
        alert("The device has only one camera");
    }else {
        this._closeinvCheckImgUpload();
        alert("The device does not have a camera");
    }
  };

  //getting the list of all available cameras
  _getListOfVideoInputs = async () => {
    // Get the details of audio and video output of the device
    const enumerateDevices = await navigator.mediaDevices.enumerateDevices();
    //Filter video outputs (for devices with multiple cameras)
    return enumerateDevices.filter((device) => device.kind === "videoinput");
  };

  //initializing the Uploading of store image data 
  _startUploadingStoreData = () =>{
    this.setState({
      uploadButtonName:'',
      uploadImageButton:{
        disabled:true,
      },
      uploadingButtonMessage:"Please wait...",
      cameraSwitchButton:'none',
      cameraResetButton:'none',
      invCheckImgUpload:false,
      //loader:''
    })
    this._appendLoaderToBody();
    const userToken = jwt_decode(localStorage.usertoken);
    const uploadLocationData = {
      ticket_id:  this.state.storeImageData.ticket_id,
      utid:       this.state.storeImageData.utid,
      lat:        this.state.storeLocation.lat,
      long:       this.state.storeLocation.long,
      sro_id:     userToken.warehouse_id,
      sro_name:   userToken.firstName+' '+userToken.lastName,
    }
    const uploadImageData = {
      ticket_id:  this.state.storeImageData.ticket_id,
      utid:       this.state.storeImageData.utid,
      image:      this.state.imageDataURL,
      sro_id:     userToken.warehouse_id,
      sro_name:   userToken.firstName+' '+userToken.lastName,
    }
    console.log("KYC Uplaod data");
    this._saveGeoLocationForKYC(uploadLocationData);
  };


  //get Inventory check Details
  async _getInventoryData(icmTicketId, anyStoreUtId){
    this._appendLoaderToBody()
    var body = {
      anyStoreUtId: anyStoreUtId
    }
    
    await axios.post(config.get('API_URL') + '/inventory/getAllUtIdsOfStore', body, 
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      console.log(response.data);
      if(typeof response.data ==='string'){
        this.setState({
          invCheckNoteError:true,
          icmErrorMessage:"UTID is not Correct, Contact system admin.",
          loader:'none',
        });
      }else{
        this.setState({
          allStoreUtid : response.data.utid,
          UTIDCountForInventoryCheck: response.data.utidCount,
          invCheckModal : true,
          storeUtIdData: [],
          finalSubmitButtonName:"save",
          currentICMTicket: icmTicketId,
          loader:'none',
        });
        console.log(this.state.allStoreUtid);
        console.log(this.state.currentICMTicket);
        console.log('my open ICM ticket data');
        console.log(this.state.onlyICMTcketData);
      }
    }).catch(error => {
      console.log('UTID Get Error');
      console.log(error);
      this.setState({
        invCheckNoteError:true,
        icmErrorMessage:"Something went wrong.",
        loader:'none',
      });
    });
  }

  //close KYC Lite Camera modal 
  _closeinvCheckImgUpload(){

    //Close Camera exiting KYC Lite Modal
    const video = document.querySelector('#videoCanvas');
    if(video!=null){
      const mediaStream = video.srcObject;
      if(mediaStream!=null){
        const tracks = mediaStream.getTracks();
        tracks.forEach(track => track.stop())
      }
    }

    this.setState({
      invCheckImgUpload:false
    });
  }

  //creating loader element and appending it to body child
  _appendLoaderToBody(){
    var loader = document.getElementById("loaderId");
    document.body.appendChild(loader);
    this.setState({
      loader:'',
    });
  }

  _closeInvCheckModal(){
    this.setState({
        invCheckModal:false
    })
  };
  _closeInvNoteModal(){
    this.setState({
      invCheckNote:false
    });
  }

  _closeInvErrorModal(){
    this.setState({
      invCheckNoteError: false,
    })
  }

  
  // resolve a ticket by ticket id
  async _resolveFDTicketById(ticketId, kycLite=false){
    console.log("Reloving FD Ticket");
    var body = {
      ticket_id: ticketId
    };

    await axios.post(config.get('API_URL') + '/inventory/resolve-ticket2',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      console.log('Resolve Response');
      console.log(response);
      
      //updating the only ICM Data
      var preUpdatedOnlyICMTicket = [...this.state.onlyICMTcketData];
      var UpdatedOnlyICMTicket = this.state.onlyICMTcketData;
      UpdatedOnlyICMTicket.splice(UpdatedOnlyICMTicket.findIndex(a => a.ticketId == ticketId) , 1);

      //updating the close tickets.
      var lastResolvedTicket = preUpdatedOnlyICMTicket.filter((d)=>{
        return d.ticketId == ticketId;
      })
      var updatedCloseTickets = this.state.MyCloseTicketData;
      updatedCloseTickets.push(lastResolvedTicket[0]);

      //updating icmTicketwithParent
      var preUpdatedICMTicketsWithParent = this.state.childTicketsWithParent;
      
      for(let i=0; i<this.state.icmParentIDs.length;i++ ){
        var matchedTicket = preUpdatedICMTicketsWithParent[i].findIndex(a => a.ticketId == ticketId);    
        if(matchedTicket!==-1){
          preUpdatedICMTicketsWithParent[i].splice(matchedTicket,1)
        }
      }
      
      //Close KYC Modal
      if(kycLite){
        this.setState({
          invCheckImgUpload:false,
          uploadButtonName:'Upload',
          cameraSwitchButton:'',
          invCheckNoteMessage:"KYC of this store is completed.",
        });
      }else{
        this.setState({
          invCheckNoteMessage:"All UTIDs has been successfullly Saved.",
        });
      }

      this.setState({
        icmCloseMessage:    "ICM ticket is resolved",
        invCheckModal:      false,
        invCheckNote:       true,
        onlyICMTcketData:   UpdatedOnlyICMTicket,
        MyCloseTicketData:  updatedCloseTickets,
        childTicketsWithParent: preUpdatedICMTicketsWithParent,

        totalICMtcikets:    this.state.totalICMtcikets-1,
        totalMyTicketCloseCount:  this.state.totalMyTicketCloseCount+1,
        loader:'none',
      });
      console.log('Updated my open ICM ticket data');
      console.log(this.state.onlyICMTcketData);
      console.log("Updated Close tickets");
      console.log(this.state.MyCloseTicketData);
    }).catch(error => {
      console.log('Resolve Ticket Error');
      console.log(error);
      this.setState({
        invCheckNoteError:true,
        icmErrorMessage:"Something went wrong",
        loader:'none',
      });
    });
  }


  //saving all utid and serial numbers
  async _finalSubmitAllSavedUtIds(){
    var localUtIdData = this.state.storeUtIdData;

    if(localUtIdData.length == this.state.allStoreUtid.length){
      this._closeInvCheckModal();
      this._appendLoaderToBody();
      // this.setState({
      //   loader:'',
      // });
      var body = {
        allUTIDs: this.state.storeUtIdData
      };
      console.log(body);
      await axios.post(config.get('API_URL') + '/inventory/saveAllUtIdsOfStore', body,
        {
          headers: {
            'Content-Type':   'application/json',
            Authorization:    `${localStorage.usertoken}`,
            SalesforceToken:  ` ${localStorage.salesforce_token}`
          }
        }
      ).then(response => {
        console.log(response.data);
        if(response.data.status){
          //calling close ticket api
          this._resolveFDTicketById(this.state.currentICMTicket);
        }else{
          alert('UTids Could not Saved');
          this.setState({
            invCheckModal:false,
          });
        }
      }).catch(error => {
        console.log('UTID saving Error');
        console.log(error);
      });
    }else{
      alert("Please complete the Inventory check form.");
    }
    
  }

  //updating Geo Location to freshDesk---> KYC Step 2
  async _updateGeoLocationFD(updateData){
    var body  =  updateData;

    await axios.post(config.get('API_URL')+'/inventory/updateFDTicketLocation',body,
      {
        headers:{
          'Content-Type':   'application/json',
          Authorization:    `${localStorage.usertoken}`,
          SalesforceToken:  `${localStorage.salesforce_token}`
        }
      }
    ).then(response=>{
      if(response.data.status){
        this._uploadImageForKYC(updateData);
      }else{
        alert("Opps! Process couldn\'t be completed");
      }
    }).catch(error=>{
      console.log("Location Update Error");
      console.log(error);
    });
  }


  //uploading image for KYC--> Final Step
  async _uploadImageForKYC(updateData){

    var fileName = Math.round(new Date().getTime()/1000).toString();
    var body = {
      attachment : this.state.imageDataURL,
      ticket_id : updateData.ticket_id,
      upload_type: "KYC Check Image",
      filename : fileName+'.png',
      file_extension : 'image/png',
      token: "bymfqp123"
    }

    //this is old API-->Being used for Jobsheet upload
    axios.post(config.get('API_URL') + '/inventory/upload-image',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      console.log('Resolved');
      console.log(response);
      if(response.data){
        this._resolveFDTicketById(updateData.ticket_id, true);
      }else{
        this.setState({
          invCheckNoteError:true,
          icmErrorMessage:"Something went wrong",
          loader:'none',
        });
      }
    }).catch(error => {
      console.log('Ticket Error');
      console.log(error);
      this.setState({
        invCheckNoteError:true,
        icmErrorMessage:"Connection lost, Please try again.",
        loader:'none',
      });
    });
    
    // await axios.post(config.get("API_URL")+'/inventory/attachStoreImageKYC',body,
    //   {
    //     headers:{
    //       'Content-Type': 'application/json',
    //       Authorization:  `${localStorage.usertoken}`,
    //       SalesforceToken:  `${localStorage.salesforce_token}`
    //     }
    //   }
    // ).then(response=>{
    //   console.log(response.data);
    //   if(response.data.status){
    //     console.log("Image Uploaded");
    //     return true;
    //   }else{
    //     console.log("Failed to upload image");
    //     return false;
    //   }
    // }).catch(error=>{
    //   console.log("Image Upload Error");
    //   console.log(error);
    //   return false;
    // });
  }


  //saving Geo Location to DB--->KYC Step 1
  async _saveGeoLocationForKYC(locationData){
    var body = {locationData:locationData};
    await axios.post(config.get('API_URL') + '/inventory/saveGeoLocationForKYC', body,
      {
        headers:{
          'Content-Type':   'application/json',
          Authorization:    `${localStorage.usertoken}`,
          SalesforceToken:  `${localStorage.salesforce_token}`
        }
      }
    ).then(response=>{
      if(response.data.status){
        //sending request to update FD
        var updateData = {
          ticket_id:  locationData.ticket_id,

          lat:  locationData.lat,
          long:  locationData.long
        }
        this._updateGeoLocationFD(updateData);
      }else{
        this.setState({
          invCheckNoteError:true,
          invCheckImgUpload:false,
          icmErrorMessage:"Connection Failed.",
          loader:'none',
        });
      }
    }).catch(error=>{
      console.log("Saving location data error.");
      console.log(error);
      this.setState({
        invCheckNoteError:true,
        invCheckImgUpload:false,
        icmErrorMessage:"Opps! Something went wrong.",
        loader:'none',
      });
    });
  }

  //disbale scrolling
  _disableScrolling = (e) =>{
    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    var keys = {37: 1, 38: 1, 39: 1, 40: 1};

    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }

    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; } 
      }));
    } catch(e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    // call this to Disable
    function disableScroll() {
      window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
      window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
      window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
      window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    function enableScroll() {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
      window.removeEventListener('touchmove', preventDefault, wheelOpt);
      window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }
    if(e=='e'){
      return enableScroll();
    }
    if(e=='d'){
      return disableScroll();
    }
  }
  //------------------------------------closing ICM functionality------------------------------------------------------

  _isVirtualSRO(){
    const token = localStorage.usertoken;
    if (token != null) {
      const decoded = jwt_decode(token);
      if(decoded.warehouse_id==='a0n2x000004XEecAAG'){
        return true
      }else{
        return false
      }
    }
  }

  _dispatchAndClosePaperRollTicket(ticketId){
    
    const ticket_details = this.state.myTicketData.filter((t)=> t.ticketId==ticketId)
    console.log(ticket_details)
    this.setState({
      confirmAWBModal:true,
      paperRollTicketId:ticketId,
      paperRollTicketData: ticket_details
    })
  }

  _viewPaperRollTicketDetails(ticketId){
    const ticket_details = this.state.myTicketData.filter((t)=> t.ticketId==ticketId)
    
    this.setState ({
      AWBViewModal:true,
      paperRollTicketData: ticket_details
    })
  }



  _closeAWBConfirmModal(modal='closure'){
    if(modal=='closure'){
      this.setState ({
        confirmAWBModal:false
      })
    }else if(modal=='details_view'){
      this.setState ({
        AWBViewModal:false
      })
    }else if(modal=='bulk_closure'){
      this.setState ({
        bulkClosure:false
      })
    }else if(modal=='retrievalOfEDC'){
      this.setState({
        openRetrievalModal:false
      })
    }
  }
  
  async _initializeBulkClosure(task){
    console.log(task)
    if(task==='init'){
      this.setState ({
        bulkClosure:true
      })
    }else if(task==='closureRequest'){
      const all_tickets = document.getElementById('all_tickets').value
      if(all_tickets.length!=0){
        this.setState({
          loader:'',
          bulkClosure:false
        })
        const body = {
          all_tickets: all_tickets
        }
        await axios.post(config.get('API_URL')+'/inventory/vsro_bulk_ticket_cloure', body,{
          headers:{
            'Content-Type':   'application/json',
            Authorization:    `${localStorage.usertoken}`,
            SalesforceToken:  ` ${localStorage.salesforce_token}`
          }
        }).then((closureResponse)=>{
          if(closureResponse.data.status){
            this.props.handleClick("tr", 1, closureResponse.data.message);
          }else{
            this.props.handleClick("tr", 2, closureResponse.data.message+', Please try again');
          }
          this.setState ({
            bulkClosure:false,
            loader:'none'
          })
        }).catch((e)=>{
          console.log(e)
          this.setState ({
            bulkClosure:false,
            loader:'none'
          })
          this.props.handleClick("tr", 3, 'Internal Error- Something went wrong, Please try again');
        })
      }else{
        this.props.handleClick("tr", 3, 'Please enter valid Ticket id in CSV');
      }      
    }else{
      this.props.handleClick("tr", 3, 'Unknown process to handle');
    }
  }

  _validateCSVs(event){
    if(/^(\d{6,7},)*\d{6,7}$/.test(event.target.value)){
      document.getElementById('submitClosureBtn').disabled=false
      document.getElementById('csvValidationError').innerHTML= ''
      document.getElementById('ticketCount').innerHTML= (event.target.value.match(/\d{6,7}/g)||[]).length
    }else if(event.target.value.length==0){
      document.getElementById('submitClosureBtn').disabled=true
      document.getElementById('csvValidationError').innerHTML= ''
      document.getElementById('ticketCount').innerHTML='0'
    }else{
      document.getElementById('submitClosureBtn').disabled=true
      document.getElementById('csvValidationError').innerHTML= 'Validation Error:- Please check the CSV format, Input valid CSV and 6 or 7 digits of ticket number'
    }
  }

  _matchAwbNumbers(){
    const awbInitInput = document.getElementById('awbInitInput').value
    const awbFinalInput = document.getElementById('awbFinalInput').value
    
    if(awbFinalInput===awbInitInput){
      document.getElementById('awbSubmitBtn').disabled = false;
    }else{  
      document.getElementById('awbSubmitBtn').disabled = true;
    }
    return
  }

  async _submitAcceptAndCloseTicket(){

    this.setState({
      loader:'',
      confirmAWBModal:false
    })

    if(true){

      const body = {
        ticketId : this.state.paperRollTicketId,
        paperRollQuantity: this.state.paperRollTicketData[0].quantity
      }
      console.log(body)
      await axios.post(config.get('API_URL') + '/sro_connect/paper_roll/resolveTicketWithClosureEvidence', body,
        {
          headers:{
            'Content-Type':   'application/json',
            Authorization:    `${localStorage.usertoken}`,
            SalesforceToken:  `${localStorage.salesforce_token}`
          }
        }
      ).then(response=>{
        
        if(response.data.status){
          var updatedMyOpenTickets = this.state.myTicketData;
          updatedMyOpenTickets.splice(updatedMyOpenTickets.findIndex(a => a.ticketId == body.ticketId) , 1);
          this.props.handleClick("tr", 1,response.data.message);
          this.setState({
            myOpenTickets: updatedMyOpenTickets,
            totalMyTicketOpenCount: Number(this.state.totalMyTicketOpenCount)-1
          })
        }else{
          this.props.handleClick("tr", 3,'Internal Error- '+response.data.message);
        }
        this.setState({
          loader:'none',
          confirmAWBModal:false,
        })
      }).catch((error)=>{
        console.log(error)
        this.setState({
          loader:'none',
          confirmAWBModal:false
        })
        this.props.handleClick("tr", 3,'Something went wrong, Please try again');
      });
      
    }else{
      alert('AWB numbers do not match')
      return
    }
  }

  _openRetrievalModal(type, ticketId, utid){

    const ticket_data = this.state.myTicketData.filter((t)=>{
      return t.ticketId === ticketId
    })

    let return_type=''
    switch(ticket_data[0].issueSubCategory){
      case 'Request of EDC retrieval - store permanently closed':
        return_type = 'retrieval'
        break
      case 'Retrieval Post Replacement':
        return_type = 'retrieval'
        break
      case 'Terminal Replacement - Not Working':
        return_type = 'retrieval'
        break
      case 'Terminal Replacement - Working':
        return_type = 'retrieval'
        break
      default:
        return_type = 'retrieval'
        break
    }

    this.setState({
      retrievalUTID: utid,
      retrievalType:  type,
      return_type: return_type,
      openRetrievalModal: true,
      retrievalTicketId: ticketId,
    })
  }

  _validateSerialNumbers(event){
    const serialNumber = document.getElementById('terminalSerialNo').value
    
    if(serialNumber===event.target.value){
      const confirmSerialNumber = document.getElementById('terminalSerialNo_cnf').value
      console.log(confirmSerialNumber)
      document.getElementById('serialNumberValidator').disabled=false
    }else{
      document.getElementById('serialNumberValidator').disabled=true
    }

  }

  async _validateTerminalSerialNumber(){
    const confirmSerialNumber = document.getElementById('terminalSerialNo_cnf').value
    if(confirmSerialNumber.length==0){
      alert('Please enter valid serial number')
      return
    }
    document.getElementById('waitingTextTerminalValidation').innerHTML = 'Please wait...'
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    const body = {
      utid: this.state.retrievalUTID,
      warehouse_id: decoded.warehouse_id,
      terminal_serial:  confirmSerialNumber
    }

    await axios.post(config.get('API_URL') + '/sro_connect/validate_terminal', body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then((response)=>{
      console.log(response.data)
      
      if(response.data.status){
        confirmAlert({
          title: 'Alert',
          buttons: [{label: 'Got it'}],
          message: 'Its innoviti Terminal. Proceed return to warehouse',
        });
        
        if(response.data.isICMP){
          document.getElementById('simSerialNumber').required=false
          document.getElementById('sim_serials').style.display='none'
          document.getElementById('retrievalSubmitBtn').disabled=false
          document.getElementById('simSerialNumber_cnf').required=false
        }else{
          document.getElementById('sim_serials').style.display=''
          document.getElementById('retrievalSubmitBtn').disabled=true
        }
        
        document.getElementById('validatedSerialNumber').value = confirmSerialNumber
        document.getElementById('validatedSerialNumberTobeSent').value = confirmSerialNumber
        document.getElementById('waitingTextTerminalValidation').innerHTML = `<span style="color:#39a339">Terminal Validated<span>`

      }else{
        confirmAlert({
          title: 'Alert',
          buttons: [{label: 'Got it'}],
          message: 'Its not innoviti Terminal. Select Terminal not Available option to process the ticket',
        });
        document.getElementById('waitingTextTerminalValidation').innerHTML = `<span style="color:#f00">Validation failed<span>`
      }
    }).catch((error)=>{
      console.log(error)
    })
    
  }

  _validateSimSerialNumber(event){
    const simSerialNumber = document.getElementById('simSerialNumber').value
    
    if(simSerialNumber===event.target.value){
      console.log(event.target.value)
      console.log('SIM Serial Matched')
      document.getElementById('retrievalSubmitBtn').disabled=false
    }else{
      console.log('Not Matched')
      document.getElementById('retrievalSubmitBtn').disabled=true
    }
  }

  async _submitRetrievalData(event){
    event.preventDefault();
    const rawForm = new FormData(event.target);
    const formData = Object.fromEntries(rawForm.entries());
    if(formData.terminalSerialNumber.length==0){
      alert('First Validate the terminal serial number')
      return
    }
    document.getElementById('waitingTextROSubmit').innerHTML = 'Please wait...'

    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);

    const body = {
      usb_cable_quantity: formData.usb,
      adapter_quantity:   formData.adapter,
      warehouse_id:       decoded.warehouse_id,
      return_type:        this.state.return_type,
      utid:               this.state.retrievalUTID,
      sim_serial:         formData.simSerialNumber_cnf,
      ticket_id:          this.state.retrievalTicketId,
      terminal_serial:    formData.terminalSerialNumber,
    }

    await axios.post(config.get('API_URL') + '/sro_connect/terminal_available', body,{
      headers:{
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then((response)=>{

      if(response.data.status){
        confirmAlert({
          title: 'Alert',
          buttons: [{label: 'Ok', onClick:()=>window.location.reload()}],
          message: 'Your request was successfull. Return order is being processed',
        });
      }else{
        confirmAlert({
          title: 'Alert',
          buttons: [{label: 'Ok'}],
          message: 'Your request was not successfull. Please retry',
        });
      }
      document.getElementById('waitingTextROSubmit').innerHTML = ''

    }).catch((error)=>{
      console.log(error)
      confirmAlert({
        title: 'Alert',
        buttons: [{label: 'Ok', onClick:()=>window.location.reload()}],
        message: 'Something went wrong. Please try again',
      });
    })

  }

  async _submitDataWhenTerminalNotAvailable(event){
    event.preventDefault();
    
    const rawForm = new FormData(event.target);
    const formData = Object.fromEntries(rawForm.entries());
    
    // if(formData.ManagerName.length==0 || /\d/.test(formData.ManagerName) || /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(formData.ManagerName)){
    if(!/^[a-zA-Z ]+$/.test(formData.ManagerName)){
      alert('Please enter a valid name')
      return
    }

    if( !/\d{10}/.test(formData.ManagerNumber)){
      alert('Please enter a valid mobile number')
      return
    }
    document.getElementById('waitingTextROSubmit').innerHTML = 'Please wait...'

    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    const body = {
      sro_phone:  decoded.phone,
      utid: this.state.retrievalUTID,
      manager_name: formData.ManagerName,
      manager_number: formData.ManagerNumber,
      sro_name: decoded.firstName+' '+ decoded.lastName,
      store_code: this.state.retrievalUTID.substring(0,6),
      ticket_id : this.state.retrievalTicketId
    }
    
    await axios.post(config.get('API_URL') + '/sro_connect/terminal_not_available_sparcs', body,{
      headers:{
        'Content-Type': 'application/json',
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then((response)=>{
      document.getElementById('waitingTextROSubmit').innerHTML = ''
      if(response.data.status){
        confirmAlert({
          title: 'Alert',
          buttons: [{label: 'Ok'}],
          message: 'Your request was successfull. Ticket is being closed',
        });
      }else{
        confirmAlert({
          title: 'Alert',
          buttons: [{label: 'Ok'}],
          message: 'Your request was not successfull. Please try again',
        });
      }
      window.location.reload();
    }).catch((error)=>{
      console.log(error)
      confirmAlert({
        title: 'Alert',
        buttons: [{label: 'Ok'}],
        message: 'Something went wrong. Please try again',
      });
    })
  }
  

  render() {

    //Component for Rendering Open Tickets except ICM Tickets
    const BindMyTickets = (props) => {
      const cardStylePurple = {
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(114 40 127)',
      }

      const cardStyleOrange ={
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(243 127 26)',
      }

      const isEven = (n)=>{
        if(n %2 === 0){
          return true;
        }
        return false;
      }

      const toggleOpenTicketView = ()=>{
        this.setState({
          openTicketView:  !this.state.openTicketView,
        });
      }

      return (
        <>
          <Button
            style={{background:'#72287f', marginBottom: '1rem', padding:12, fontSize:15}}
            className="poc-mainButtonWith" id="idMyOpenTickets"
            onClick={toggleOpenTicketView}
            
            >
            My Open Tickets ({this.state.totalMyTicketOpenCount})
            <span className="pull-right">
              <i className={(this.state.openTicketView)?"pe-7s-angle-down":"pe-7s-angle-right"} style={{fontSize:18}}></i>
            </span>
          </Button>
          <Collapse isOpen={this.state.openTicketView}>
            {
              (this.state.totalMyTicketOpenCount>0)?
                this.state.myTicketData.map((data, index)=>(
                  <Card style={(isEven(index))?cardStyleOrange:cardStylePurple} key={index}>
                    <CardBody className="">
                      <div>
                        <label style={{fontSize:13}}><b>Ticket Id: </b>{data.ticketId}</label>&nbsp;&nbsp;<label style={{fontSize:13}}>Priority: {data.priority}</label><br/>
                        <label style={{fontSize:13}}><b>UTID: </b>{data.utid}</label><br/>
                        <label style={{fontSize:13}}><b>Category: </b>{data.issueSubCategory}</label><br/>
                        <label style={{fontSize:13}}><b>Proactive Count: </b>{( data.proactiveChecks || 0)} </label>
                      </div>       
                      {/* Retrieval Tickets */}
                      {data.issueSubCategory.toLowerCase().includes("retrieval")==true ?
                      
                        <>                 
                          <div className="">
                            <form>
                              <div className="terminalfoundradio">
                                <label>
                                  <input style={{ marginRight: 5 }} type="radio" value="Terminal Available" checked={false} onClick={() => this._openRetrievalModal('available', data.ticketId, data.utid)} />
                                  Terminal  Available
                                </label>
                              </div>
                              <div className="terminalnotavailable">
                                <label>
                                  <input style={{ marginRight: 5 }} type="radio" value="Terminal Available" checked={false} onClick={() => this._openRetrievalModal('not_available', data.ticketId, data.utid)} />
                                  Terminal Not Available
                                </label>
                              </div>
                            </form>
                          </div>
                        </>
                      :null
                      }
                      {/* Common buttons for every ticket */}
                      <div className="text-center" style={{marginTop:15}}>
                        <div className="btn-group mr-2">
                          <button className="btn btn-primary" style={{marginRight:10,background:'#72287f',fontSize:10}}
                            onClick={() => this._onclickModalmyTickets1(data.ticketId, data.utid, data.store)}>Job Sheet
                          </button>
                          <button  className="btn btn-primary" style={{marginRight:10,background:'rgb(243 127 26)',fontSize:10}}
                            onClick={() => this._onclickModalmyTickets(data.priority, data.ticketId, data.utid, data.store, data.storeAddress, data.issueSubCategory, data.dispatcherDate, data.dispatcherSource, data.issueType, data.dispatchTime, data.iskuName, data.iskuDesc, data.merchantContactNumber, data.cf_retrieval_terminal_serial_number, data.proactiveChecks)}>View
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                ))
                :
                <Card style={cardStylePurple}>
                  <CardBody className="text-center">
                    <span style={{fontSize:12}}>You don't have open tickets</span>.
                  </CardBody>
                </Card>
            }
          </Collapse>
        </>
      )
    };

    // Component for rendering the close ticket details
    const BindMyCloseTickets = ()=> {
      const cardStylePurple = {
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(114 40 127)',
      }

      const cardStyleOrange ={
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(243 127 26)',
      }

      const isEven = (n)=>{
        if(n %2 === 0){
          return true;
        }
        return false;
      }

      const toggleResolvedTicketView = ()=>{
        this.setState({
          resolvedTicketView:  !this.state.resolvedTicketView,
        });
      };

      return (
        <>
          <Button
            style={{background:'#72287f',marginBottom: '1rem',padding:12, fontSize:15}}
            onClick={toggleResolvedTicketView}
            className="poc-mainButtonWith" id="idMyCloseTickets"
            >
            My Resolved Tickets ({this.state.totalMyTicketCloseCount})
            <span className="pull-right">
              <i className={(this.state.resolvedTicketView)?"pe-7s-angle-down":"pe-7s-angle-right"} style={{fontSize:18}}></i>
            </span>
          </Button>

          <Collapse isOpen={this.state.resolvedTicketView} className="poc">
            {
              (this.state.totalMyTicketCloseCount>0)?
                this.state.MyCloseTicketData.map((data, index)=>(
                  <Card style={(isEven(index))?cardStyleOrange:cardStylePurple} key={index}>
                    <CardBody className="">
                      <div>
                        <span>
                          <button  className="btn btn-primary pull-right" style={{marginRight:10,background:'rgb(243 127 26)',fontSize:10}}
                            onClick={() => this._onclickModalmyTickets(data.priority, data.ticketId, data.utid, data.store, data.storeAddress, data.issueSubCategory, data.dispatcherDate, data.dispatcherSource, data.issueType, data.dispatchTime, data.iskuName, data.iskuDesc, data.merchantContactNumber, data.cf_retrieval_terminal_serial_number, data.proactiveChecks)}>View
                          </button>
                        </span> 
                        <label style={{fontSize:13}}><b>Ticket Id: </b>{data.ticketId}</label>&nbsp;&nbsp;<label style={{fontSize:13}}><b>Priority: </b> {data.priority}</label><br/>
                        <label style={{fontSize:13}}><b>UTID: </b>{data.utid}</label><br/>
                        <label style={{fontSize:13}}><b>Category: </b>{data.issueSubCategory}</label><br/>
                      
                      </div>
                    </CardBody>
                  </Card>
                ))
              :
              <Card style={cardStylePurple}>
                <CardBody className="text-center">
                  <span style={{fontSize:12}}>You don't have resolved tickets.</span>
                </CardBody>
              </Card>
            }
          </Collapse>
        </>
      )
    };

    const bindMystockSummary = this.state.myStockSummary.map((data, index) => {
      return (
        <div className="poc-myStock_tr">
          <b>{data.SKU__r?data.SKU__r.Description__c:null}</b>
          <br/>
          <span className="poc-myStock_tr-label-color"> <b>Stock:</b> {data.Current_Stock__c} &nbsp;&nbsp; &nbsp;&nbsp;
            <b>Return To Warehouse:</b> {data.quantityToBeReturned__c}</span>
        </div>
      )
    });

    const bindCollectWorkOrder = this.state.collectWorkOrder.map((data, index) => {
      return (
        <div className="poc-myStock_tr">
          <b>{data.skudesc}</b>
          <br/>
          <span className="poc-myStock_tr-label-color"> <b>QTY:</b> {data.quantity} &nbsp;&nbsp; &nbsp;&nbsp;<b>Order ID:</b> {data.orderid}</span>
          <br/>
          <b>Asset Serial Number:</b> {('assestSerialNumber' in data && data.assestSerialNumber.length)? data.assestSerialNumber[0]:'not available'}
        </div>
      )
    });

    const bindReturnWorkOrder = this.state.returnWorkOrder.map((data, index) => {
      return (
        <div className="poc-myStock_tr">
          <b>{data.skudesc}</b>
          <br/>
          <span className="poc-myStock_tr-label-color"> <b>QTY:</b> {data.quantity} &nbsp;&nbsp; &nbsp;&nbsp;<b>Order ID:</b> {data.orderid}</span>
          <br/>
          <b>Asset Serial Number:</b> {('assestSerialNumber' in data && data.assestSerialNumber.length)? data.assestSerialNumber[0]:'not available'}
        </div>
      )
    });


    /*
      ICM Ticket proccessing Component. Populating Form for Inventory check and Maintenance.
      Author- sabir.ansari@innoviti.com
    */
    const UtidSaveFormsComponent = () => {
      
      //----------------------------------------------------------------------------------------
      /*
        Jira Ticket- 
        Author- 

      */
      const hideutidFormDiv = {
        display:'none'
      };

      const inputMsgStyle = {
        fontSize: 10
      };

      const EditLinkStyle = {
        fontSize:10,
        display:'None',
      };

    
      const hideUtidFormDiv = (divId) =>{
        document.getElementById("finalSubmitButtonId").disabled = false;
        document.getElementById(divId+"divForm").style.display = "none";
        document.getElementById(divId+"divRemarkForm").style.display = ""
      };

      const showUtidFormDiv = (divId) =>{
        document.getElementById("finalSubmitButtonId").disabled = false;
        document.getElementById(divId+"divForm").style.display = "";
        document.getElementById(divId+"divRemarkForm").style.display = "none";
      };

      //Comparing both serial Numbers and creating event to submit the Form
      const compareTwoSerials = (utid) =>{
        var x = document.getElementById("myInput1"+utid).value;
        var y = document.getElementById("myInput2"+utid).value;

        if(x==y){
          document.getElementById("submit"+utid).click();
          var element = document.getElementById("inputMsg"+utid);
          element.classList.remove("text-danger");
          element.classList.add("text-success");
          document.getElementById("inputMsg"+utid).innerHTML ="Serial Numbers Locked  ";
          document.getElementById("inputMsg"+utid).style.display='inline'
          document.getElementById("editLink"+utid).style.display= '';
        }else{
          var element = document.getElementById("inputMsg"+utid);
          element.classList.remove("text-success");
          element.classList.add("text-danger");
          document.getElementById("inputMsg"+utid).innerHTML ="Serial Numbers do not match";
        }

      };


      //handling saving of each Serial number to state array "storeUtIdData"
      const handleTempSaveUtId = (event) =>{
        event.preventDefault();

        const data = new FormData(event.target);
        const value = Object.fromEntries(data.entries());

        var localUtIdData = this.state.storeUtIdData;
        const token = localStorage.usertoken;

        let sro_id = '';
        let username = '';

        if (token != null) {
          const decoded = jwt_decode(token);
          sro_id = decoded.warehouse_id;
          username= decoded.firstName +' '+decoded.lastName;
        }

        if(localUtIdData.some(item => item.utid === value.utid)){
          alert("Serial Number Already Saved");
          this._closeInvCheckModal();
        }else{
          value.sro_id = sro_id;
          value.sro_name = username;
          value.fd_ticket_id = this.state.currentICMTicket;

          localUtIdData.push(value);
          document.getElementById("myInput1"+value.utid).readOnly = true;
          document.getElementById("myInput2"+value.utid).readOnly = true;
        }

        if(localUtIdData.length == this.state.allStoreUtid.length){
          document.getElementById("finalSubmitButtonId").disabled = false;
        }
        console.log(localUtIdData);
      };

      //Editing the serial Number after entring Serial Numbers
      const editLastSerial = (utid) =>{
        var localUtIdData = this.state.storeUtIdData;
        document.getElementById("finalSubmitButtonId").disabled = true;
        localUtIdData.splice(localUtIdData.findIndex(a => a.utid === utid) , 1);

        var element = document.getElementById("inputMsg"+utid);

        element.classList.remove("text-success");
        document.getElementById("inputMsg"+utid).style.color='white';
        document.getElementById(utid+"Form").reset();
        document.getElementById("myInput1"+utid).readOnly = false;
        document.getElementById("myInput2"+utid).readOnly = false;

        console.log(localUtIdData);
      };

      //Updating Remark in case of asset is not available
      const updateRemarks = (utid) =>{
        var localUtIdData = this.state.storeUtIdData;

        if(localUtIdData.some(item=>item.utid===utid)){
          document.getElementById("finalSubmitButtonId").disabled = true;
          localUtIdData.splice(localUtIdData.findIndex(a => a.utid === utid) , 1);
          console.log(localUtIdData);
        }
      }

      const handleSaveRemark = (utid)=>{
        document.getElementById("submitRemark"+utid).click();
      };

      const hrDesign = {
        border: 0,
        height: '1px',
        background: '#333',
        backgroundImage: 'linear-gradient(to right, #fff,#72287f, #fff)',
      }


      return (
        
        <div>
          <ModalBody style={(this.state.UTIDCountForInventoryCheck > 5)?{height: '50vh', overflowY: 'auto'}:{}}>
                
            {
              this.state.allStoreUtid.map((item,index)=>(
                <React.Fragment>
                  <Row className="show-grid" key={index}>
                    <Col md={4}>
                      UTID: - {item}
                    </Col>

                    <Col md={8}>

                      <div className="radio-inline">
                        <label>
                          <input type="radio" id={item + "av"} name={item + "teminalAvailability"} value="available" onClick={() => showUtidFormDiv(item)} />
                          Available
                        </label>
                      </div>

                      <div className="radio-inline">
                        <label>
                          <input type="radio" id={item + "noav"} name={item + "teminalAvailability"} value="Not Available" onClick={() => hideUtidFormDiv(item)} />
                          Not Available
                        </label>
                      </div>

                      <div id={item + "divForm"} style={hideutidFormDiv}>
                        <form id={item + "Form"} onSubmit={(e) => handleTempSaveUtId(e)} autoComplete="off">
                          <Row className="show-grid">
                            <Col md={6}>
                              <div className="form-group">
                                <input type="hidden" className="form-control input-sm" name="asset_availability" value="available" />
                                <input type="hidden" className="form-control input-sm" name="utid" value={item} />
                                <input type="text" className="form-control input-sm" id={"myInput1" + item} name="serial_number" maxLength={30} placeholder="Enter Serial number" required />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="form-group">
                                <input type="text" className="form-control  input-sm" id={"myInput2" + item} name="serial_number" maxLength={30} placeholder="Re-Enter Serial number" required onChange={() => compareTwoSerials(item)} />
                              </div>
                            </Col>
                          </Row>

                          <div style={{marginTop:-12}}>
                            <p id={"inputMsg" + item} style={inputMsgStyle}></p>
                            <a href="javaScript:void(0)" style={EditLinkStyle} id={"editLink" + item} onClick={() => editLastSerial(item)}> EDIT</a>
                          </div>

                          <button type="submit" style={this.state.disableSubmit} className="btn btn-sm btn-success" id={"submit" + item}></button>
                        </form>
                      </div>

                      <div id={item + "divRemarkForm"} style={hideutidFormDiv}>
                        <form id={item + "RemarkForm"} onSubmit={(e) => handleTempSaveUtId(e)} autoComplete="off">
                          <Row className="show-grid">
                            <Col md={6}>
                              <div className="form-group">
                                <input type="hidden" className="form-control input-sm" name="asset_availability" value="not available" />
                                <input type="hidden" className="form-control input-sm" name="utid" value={item} />
                                <input type="text" className="form-control input-sm" id={"remark" + item} name="remark" onFocusCapture={() => updateRemarks(item)} onBlur={() => handleSaveRemark(item)} placeholder="Remark" required />
                              </div>
                            </Col>
                          </Row>
                          <button type="submit" style={this.state.disableSubmitRemark} className="btn btn-sm btn-success" id={"submitRemark" + item}></button>
                        </form>
                      </div>

                    </Col>
                  </Row>
                  
                  <hr style={hrDesign}/>
                </React.Fragment>
              ))
            }
          </ModalBody>
          <ModalFooter>
            <Button
              id="finalSubmitButtonId"
              onClick={()=>this._finalSubmitAllSavedUtIds()}
              style={{background:'rgb(243 127 26)'}}
              >
              {this.state.finalSubmitButtonName}
            </Button>
            <Button color="danger" onClick={()=>this._closeInvCheckModal()}>Cancel</Button>
          </ModalFooter>
          

        </div>
      )
    };

    //--------------------------------- END of ICM Processing Component-------------------------------------------------------


    /*
      ICM Ticket processing Component. Populating UI for KYC Check
      Author- sabir.ansari@innoviti.com

    */

    const KYCProcessComponent = () => {

      const cardStylePurple = {
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(114 40 127)',
      }


      const cardStyleOrange ={
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(243 127 26)',
      }

      const isEven = (n)=>{
        if(n %2 === 0){
          return true;
        }
        return false;
      }

      const toggleICMTicketView = ()=>{
        this.setState({
          ICMTicketView:  !this.state.ICMTicketView,
        });
      };

      //check for Job sheet upload status and return bool
      const checkUploadedJobSheet = (ticketId)=>{
        const uploadData = JSON.parse(window.localStorage.getItem('uploaded_job_sheet'));

        if(uploadData!==null){
          console.log(uploadData);
        
          console.log("Seaching... ticket id");
          const ticketAvailability = uploadData.filter((a)=>{
            return a.invCheckButtonId === ticketId
          })

          
          console.log(ticketAvailability);
          if(Object.keys(ticketAvailability).length){
            return true;
          }else{
            return false;
          }
        }else{
          return false;
        }
        
      }

      //Init Upload Job sheet
      const initUploadJobSheet = (event,ticketId, utid)=>{
        const buttonId = event.target.id;

        if(checkUploadedJobSheet(ticketId)){
          alert("Your job sheet is already uploaded.");
          document.getElementById(ticketId+'js').disabled=true;
        }else{
          this.setState({
            uploadButtonId: buttonId,
            ticketId1: ticketId,
            utid1: utid,
            modalIssue1: this.state.modalIssue1 === true ? false : true,
          })
        }
      }


      
      return (
        
        <>
          <Button
            className="poc-mainButtonWith" 
            style={{marginBottom: '1rem', background:'#72287f', color:'white', padding:12, fontSize:15}}
            onClick={toggleICMTicketView}
            
            >
              My ICM Tickets ({this.state.icmParentIDs.length})
              <span className="pull-right">
                <i className={(this.state.ICMTicketView)?"pe-7s-angle-down":"pe-7s-angle-right"} style={{fontSize:18}}></i>
              </span>
              
          </Button>

          <Collapse isOpen={this.state.ICMTicketView}>
            {
              (this.state.totalICMtcikets>0)?

                this.state.childTicketsWithParent.map((data,index)=>{
                  
                  //fixing indices
                  if(data.length==2){

                    if(data[0].subject.toLowerCase() !=='inventory check'){
                      const temp = data[0];
                      data[0] = data[1];
                      data[1] = temp
                    }
                  }
                  

                  if(data.length>0){
                    return(
                    
                      <Card  style={(isEven(index))?cardStyleOrange:cardStylePurple} key={index}>
                        <CardBody className="">
                          {/* View Button */}
                          <div className="pull-right">
                            <button  className="btn btn-primary" style={{marginRight:10,background:'rgb(243 127 26)',fontSize:10}}
                              onClick={() => this._onclickModalmyTickets(data[0].priority, data[0].ticketId, data[0].utid, data[0].store, data[0].storeAddress, data[0].issueSubCategory, data[0].dispatcherDate, data[0].dispatcherSource, data[0].issueType, data[0].dispatchTime, data[0].iskuName, data[0].iskuDesc, data[0].merchantContactNumber, data[0].cf_retrieval_terminal_serial_number, data[0].proactiveChecks)}>View
                            </button>
                          </div>

                          <div>
                            <label style={{fontSize:13}}><b>Ticket Id: </b>{data[0].ticketId}</label>&nbsp;&nbsp;<label style={{fontSize:13}}><b>Priority: </b> {data[0].priority}</label><br/>
                            <label style={{fontSize:13}}><b>UTID: </b>{data[0].utid}</label><br/>
                            <label style={{fontSize:13}}><b>Category: </b>{data[0].issueSubCategory}</label><br/>
                            <label style={{fontSize:13}}><b>Subject: </b>{data[0].subject}</label><br/>
                            <label style={{fontSize:13}}><b>Proactive Count: </b>{( data[0].proactiveChecks || 0)} </label>
                          </div>
                          
                          <div className="text-center" style={{marginTop:15}}>
                            <div className="btn-group mr-2">
                              {
                                (data.length === 2)?
                                <>
                                  {/* KYC Button Enabled */}
                                  <button
                                    id={data[1].ticketId+'kyc'}
                                    className="btn btn-primary"
                                    style={{marginRight:10,background:'#72287f',fontSize:10}}
                                    onClick={() => this._getKYCData(data[1].ticketId, data[1].utid)}
  
                                    >
                                      KYC Lite
                                  </button>

                                  {/* Inventory Check disbaled */}
                                  <button
                                    id={data[0].ticketId+'icheck'}
                                    className="btn btn-primary"
                                    style={{marginRight:10,background:'#4e505a',fontSize:10,color:'#fff'}}
                                    disabled={true}
  
                                    >
                                      &nbsp;Check&nbsp;
                                  </button>
                                </>
                                :
                                <>
                                
                                  {/* KYC Button disabled */}
                                  <button
                                    className="btn btn-primary"
                                    style={{marginRight:10,background:'#4e505a',fontSize:10,color:'#fff'}}
                                    disabled={true}
  
                                    >
                                      KYC Lite
                                  </button>

                                  {/* Inventory Check  */}
                                  <button
                                    id={data[0].ticketId+'icheck'}
                                    className="btn btn-primary"
                                    style={{marginRight:10,background:'#72287f',fontSize:10,color:'#fff'}}
                                    onClick={() => this._getInventoryData(data[0].ticketId, data[0].utid)}
                                    
                                    //check for the successfull job sheet upload and if uploaded make buttoon Enable or disable
                                    disabled={(checkUploadedJobSheet(data[0].ticketId))?false:true}
                                    >
                                      &nbsp;Check&nbsp;                                  
                                  </button>
                                </>
                              }                            

                              {/* Upload Job Sheet Button */}
                              <button
                                id={data[0].ticketId+'js'} 
                                className="btn btn-primary"
                                style={{marginRight:10,background:'#72287f',fontSize:10,color:'#fff'}}
                                onClick={(e) => initUploadJobSheet(e, data[0].ticketId, data[0].utid)}
                                
                                //check inventory check button status to enable or disable 
                                disabled={(data.length==2)?true:false}
                                >
                                job Sheet
                              </button>
                              
                              
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    )
                  }
                  
                }):

                <Card style={cardStylePurple}>
                  <CardBody className="text-center">
                    <span style={{fontSize:12}}>You don't have ICM tickets.</span>
                  </CardBody>
                </Card>
            }
          </Collapse>
        </>
      );
    };
    //----------------------------------END Of ICM KYC Check processing component------------------


    //loader style
    const loading = {
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 111,
      backgroundColor: "#FFF",
      opacity: 0.75,
      width: "100%",
      height: "100%",
      display:"",
      margin:'auto'
    }


    //not added Functionality
    const toggleEmptyTicketView = (button)=>{
      switch(button){
        case 'icm':
          alert("You have no ICM Tickets");
          break;
        case 'open':
          alert("You have no Open Tickets");
          break;
        case 'close':
          alert("You have no Close Tickets");
          break;
        default:
          alert("No Status found");
          break;
      }
    };  

    const MainJsx = ()=>{
      return(
        <>
          {/* main Container */}
          <div className="container-fluid bgcolor">

            <div className="row" style={{marginTop:10}}>

              <div className="col-md-6">
                <button  className="btn btn-primary" style={{marginRight:10,background:'#72287f'}}
                  onClick={() => this._refreshPage()}>
                    <i className="pe-7s-refresh" style={{color:'#ffffff'}}></i>
                </button>

                <button className="btn btn-primary" style={(this.state.showHideAttendanceBtn)?{marginRight:10,background:'#4e505a',color:'#ffffff'}:{marginRight:10,background:'#72287f',color:'#ffffff'}} 
                  disabled={this.state.showHideAttendanceBtn}
                  onClick={() => this._markAttandance()}>Mark Attendance
                </button>

                <button
                  className="btn btn-primary"
                  style={{marginRight:10,background:'rgb(243, 127, 26)'}} 
                  >
                    <a href="/admin/logout/">
                      <i className="pe-7s-power" style={{color:'#ffffff'}}></i>
                    </a>
                </button>
              </div>
            
            </div>

            <div className="row" style={{marginTop:20}}>
              {/* Main Content */}
              <div className="col-md-12">

                {/* rendring the My open tickets */}
                <BindMyTickets/>

                {/* rendering the KYC Check */}
                <KYCProcessComponent/>
                
                {/* rendering the my close tickets */}
                <BindMyCloseTickets/>


                <Button style={{background:'#72287f', marginBottom: '1rem',color:'white', padding:12, fontSize:15}} className="poc-mainButtonWith" id="StockSummary" disabled={this.state.showHideOtherBtn}>
                  My Stocks
                </Button>
                <UncontrolledCollapse toggler="#StockSummary">
                  <Card>
                    <CardBody className="poc-blockPadding">
                      <div className="poc-marginmainblock">
                        {this.state.myStockSummary.length > 0 ? "" : <label>There are no record to display</label>}
                        {bindMystockSummary}
                      </div>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>


                <Button style={{background:'#72287f',marginBottom: '1rem',color:'white', padding:12, fontSize:15}} className="poc-mainButtonWith" id="WorkOrder"  disabled={this.state.showHideOtherBtn}>
                  Work Order
                </Button>
                <UncontrolledCollapse toggler="#WorkOrder">
                  <Card>
                    <CardBody>
                      <div className="poc-marginmainblock">
                        <br/>
                        <div className="poc-workorder-head">Collect</div>
                        {this.state.collectWorkOrder.length > 0 ? "" : <label>There are no record to display</label>}
                        {bindCollectWorkOrder}
                        <div className="poc-workorder-head">Return</div>
                        {this.state.returnWorkOrder.length > 0 ? "" : <label>There are no record to display</label>}
                        {bindReturnWorkOrder}
                      </div>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>


                <Button style={{background:'#72287f',marginBottom: '1rem', color:'white', padding:12, fontSize:15}} className="poc-mainButtonWith" id="downloadBinaryApp" onClick={this.bindBinaryTable.bind(this)}>
                  Download Binary App
                </Button>
                
                <UncontrolledCollapse toggler="#downloadBinaryApp">
                  <Card>
                    <CardBody>
                      <div className="poc-marginmainblock">
                        <br/>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card">
                              <div className="col-md-9 no-padd">
                                <div className="header">
                                  <h4 className="title">Download Binary App</h4>
                                </div>
                              </div>
                              <div className="clearfix"></div>
                              <div className="content">
                                <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                  <label>Device</label>
                                  <ReactMultiSelectCheckboxes
                                    name="device"
                                    isMulti
                                    value={(this.state.deviceValues || [])}
                                    className="table-bordered"
                                    isClearable={false}
                                    onChange={this._onDeviceChange.bind(this)}
                                    options={(this.state.deviceList || [])}
                                    placeholderButtonLabel="Select [Device]"
                                  />
                                </div>
                                <div className="col-md-2 filter-bottom5 date-icon-small">
                                  <div className="form-group">
                                    <label>Product</label>
                                    <ReactMultiSelectCheckboxes
                                      name="subvention"
                                      isMulti
                                      value={(this.state.productValues || [])}
                                      className="table-bordered"
                                      isClearable={false}
                                      onChange={this._onProductChange.bind(this)}
                                      options={(this.state.productList || [])}
                                      placeholderButtonLabel="Select [Product]"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-2 filter-bottom5 date-icon-small">
                                  <div className="form-group">
                                    <label>Version</label>
                                    <ReactMultiSelectCheckboxes
                                      name="subvention"
                                      isMulti
                                      value={(this.state.versionValues || [])}
                                      className="table-bordered"
                                      isClearable={false}
                                      onChange={this._onVersionChange.bind(this)}
                                      options={(this.state.versionList || [])}
                                      placeholderButtonLabel="Select [Version]"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 filter-bottom5 date-icon-small pull-left">
                                  <br/>
                                  <button type="button" className="primary apply-filter" role="button"
                                          style={{float: 'left'}}
                                          onClick={this._fetchRecordByFilter.bind(this)}>Apply
                                  </button>
                                  &nbsp;
                                  <button type="button" className="primary apply-filter" role="button"
                                          style={{float: 'left'}}
                                          onClick={this._removeFilter.bind(this)}>Remove Filter
                                  </button>
                                </div>
                                <div className="clearfix"></div>
                                <div className="clearfix"></div>
                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                  <table id="tblBinaryAppDetails" className="table table-striped table-hover"
                                          width="100%">
                                    <thead>
                                    <tr width="100%">
                                      <th>Device</th>
                                      <th>Product</th>
                                      <th>Version</th>
                                      <th>Release Date</th>
                                      <th>Download</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>

              </div>
              
            </div>
          </div>
            
          {/* style={{position:'inherit'}} */}
          <Modal id="myTicketsModal" isOpen={this.state.modalIssue}
                toggle={() => this._onclickModalmyTickets("", "", "", "", "", "", "", "", "", "", "", "", "", "", "")}
                className="poc-modal-width" >
            <ModalHeader
              toggle={() => this._onclickModalmyTickets("", "", "", "", "", "", "", "", "", "", "", "", "", "", "")} style={{backgroundColor:'rgb(114 40 127)'}}>Ticket
              Details</ModalHeader>
            <ModalBody>
              <table>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Calculated Priority:</b> {this.state.ticketDetails.priority}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Ticket ID:</b> {this.state.ticketDetails.ticketId}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>UTID:</b> {this.state.ticketDetails.utid}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Store Name:</b> {this.state.ticketDetails.store}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Store Details:</b> {this.state.ticketDetails.storeAddress}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Issue Type</b> {this.state.ticketDetails.issueType}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Issue Category:</b> {this.state.ticketDetails.issueSubCategory}</td>
                </tr>
                {(this.state.ticketDetails.cfRetrievalTSN || "").trim() === "Request of EDC retrieval - store permanently closed" ?
                  <tr className="poc-ticket-modal-tr">
                    <td><b>Retrieval Terminal Serial Number:</b> {this.state.ticketDetails.cfRetrievalTSN}</td>
                  </tr> : ""
                }
                <tr className="poc-ticket-modal-tr">
                  <td><b>Dispatch Details:</b> {this.state.ticketDetails.dispatcherSource}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Dispatch Date:</b> {this.state.ticketDetails.dispatchTime}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>ISKU Name:</b> {this.state.ticketDetails.iskuName}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>ISKU Description:</b> {this.state.ticketDetails.iskuDesc}</td>
                </tr>
                <tr className="poc-ticket-modal-tr">
                  <td><b>Merchant Number:</b> {this.state.ticketDetails.merchantContactNumber}</td>
                </tr>
              {/* { <tr className="poc-ticket-modal-tr">
                  <td><b>Proactive Count:</b> {(this.state.ticketDetails.proactiveChecks || 0)}</td>
                </tr> } */}
              </table>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={() => this._sendStoreLocation()}>Send Store Geo Location</Button>
              <Button color="primary">Check Transaction</Button>
              <Button color="secondary"
                      onClick={() => this._onclickModalmyTickets("", "", "", "", "", "", "", "", "", "", "", "", "", "", "")}>Cancel</Button>

            </ModalFooter>
          </Modal>

          <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
            <div className="download-popup-model">
              <div className="message-content">
                {this.state.file_url == '' ?
                  <div>
                    <p>Generating file...</p>
                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                      <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                    </a>
                  </div>
                  :
                  <div className="dwnloadLink">
                    <a href="#" onClick={this.downloadFile.bind(this)}>
                      <i className="fa fa-download" aria-hidden="true"></i>Download
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                      <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                    </a>
                  </div>
                }
              </div>
            </div>
          </ModalD>




          {/* Devs*/}
          <Modal id="myScanModel"
            isOpen={this.state.openRetrievalModal}
            toggle={() => this._closeAWBConfirmModal('retrievalOfEDC')}
            className="poc-modal-width"
          >
            <ModalHeader  
              toggle={() => this._closeAWBConfirmModal('retrievalOfEDC')}
              style={{backgroundColor:'rgb(114 40 127)'}}
            >
                {'Retrieval of EDC'}
            </ModalHeader>
            <ModalBody style={{height: '50vh', overflowY: 'auto'}}>
                    
                    {
                      this.state.retrievalType ==='available'
                      ?
                      <>
                          <div style={{borderStyle:'none',borderWidth:1, padding:5, borderColor:'#ccc', borderRadius:3}}>
                            <Row className="show-grid" style={{backgroundColor:''}}>
                                            
                                <Col md={6} style={{marginBottom:10}}>
                                    <p>Enter Serial Number<span><sup style={{color:'#f00'}}>*</sup></span></p>
                                    <input
                                      className="form-control input-sm"
                                      type="text"
                                      id="terminalSerialNo"
                                      maxLength="30"
                                      autoComplete="off"
                                    />
                                </Col>
                                
                                <Col md={6}>
                                  <p>Re-Enter Serial Number<span><sup style={{color:'#f00'}}>*</sup></span></p>
                                  <input
                                    className="form-control input-sm"
                                    type="text"
                                    id="terminalSerialNo_cnf"
                                    maxLength="30"
                                    onChange={(e)=>this._validateSerialNumbers(e)}
                                    autoComplete="off"
                                  />
                                </Col>
                            </Row>
                            <Row className="show-grid" style={{}}>
                              <Col>
                                <div style={{marginTop: 10,padding:5, marginLeft:10}}>
                                  <button
                                    id="serialNumberValidator"
                                    className="btn btn-primary pull-left"
                                    style={
                                      {
                                        marginRight:10,
                                        background:'#72287f',
                                        fontSize:10
                                      }
                                    }
                                    onClick={() => this._validateTerminalSerialNumber()}
                                  >
                                    Validate Terminal
                                  </button>
                                </div>
                                <div>
                                  <p id={'waitingTextTerminalValidation'}></p>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          
                          <form id="retrievalForm" onSubmit={(e)=>this._submitRetrievalData(e)} autoComplete="off">
                            <div style={{borderStyle:'none',borderWidth:1, padding:5, borderColor:'#ccc', borderRadius:3, marginTop:8}}>
                              <Row className="show-grid"> 
                                  <Col md={6}>
                                  <p>Terminal Serial Number<span><sup style={{color:'#f00'}}>*</sup></span></p>
                                  <input
                                      className="form-control input-sm"
                                      type="text"
                                      id="validatedSerialNumber"
                                      disabled
                                  />
                                  </Col>
                              </Row>
                              
                              <Row className="show-grid" style={{backgroundColor:''}} id="sim_serials">
                                  <input type="hidden" name="terminalSerialNumber" id="validatedSerialNumberTobeSent"/>
                                  <Col md={6} style={{marginTop:10}}>
                                      <p>Sim Serial Number<span><sup style={{color:'#f00'}}>*</sup></span></p>
                                      <input
                                          className="form-control input-sm"
                                          type="text"
                                          name="simSerialNumber"
                                          id="simSerialNumber"
                                          required
                                      />
                                  </Col>

                                  <Col md={6} style={{marginTop:10}}>
                                      <p>Re-Enter Sim Serial Number<span><sup style={{color:'#f00'}}>*</sup></span></p>
                                      <input
                                          className="form-control input-sm"
                                          type="text"
                                          name="simSerialNumber_cnf"
                                          id="simSerialNumber_cnf"
                                          onChange={(e)=>this._validateSimSerialNumber(e)}
                                          required
                                      />
                                  </Col>
                              </Row>

                              <Row className="show-grid" style={{backgroundColor:''}}>
                                            
                                <Col md={6}>
                                  <div style={{padding:10}}>
                                    <p>Adapter Quantity</p>
                                    <div style={{flexDirection:'row', justifyContent:'space-between'}}>
                                      <input type="radio" value="0" name="adapter"/> 0
                                      <input type="radio" value="1" name="adapter" style={{marginLeft:10}} defaultChecked/> 1
                                    </div>
                                  </div> 
                                </Col>

                                <Col md={6}>
                                  <div style={{padding:10}}>
                                    <p>USB Cable Quantity</p>
                                    <div style={{flexDirection:'row', justifyContent:'space-between'}}>
                                      <input type="radio" value="0" name="usb"/> 0
                                      <input type="radio" value="1" name="usb" style={{marginLeft:10}} defaultChecked/> 1
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row className="show-grid" style={{backgroundColor:''}}>
                                <Col md={6}>
                                  <div  style={{padding:10}}>
                                    <p>Terminal Damaged</p>
                                    <div style={{flexDirection:'row', justifyContent:'space-between'}}>
                                      <input type="radio" value="yes" name="damaged"/> Yes
                                      <input type="radio" value="no"  name="damaged" style={{marginLeft:10}} defaultChecked/> No
                                    </div>
                                  </div>
                                </Col>

                                <Col md={6}>
                                {
                                    this.state.is_damage==='yes'?
                                    <>
                                        <p>Upload Terminal Damaged File</p>
                                        <input
                                            id="fileButton"
                                            onChange={this.fileChangedHandler}
                                            name ="terminalDamaged"
                                            type="file"
                                        />
                                    </>
                                :
                                null
                                }
                                </Col>
                              </Row>
                            </div>

                            <div style={{marginTop:20,float:'right', marginBottom:20, paddingBottom:30}}>
                              <div>
                                <p id={'waitingTextROSubmit'}></p>
                              </div>
                              <button
                                className="btn btn-primary"
                                type={'submit'}
                                id={'retrievalSubmitBtn'}
                                style={{marginRight:10,background:'rgb(140 40 127)',fontSize:10}}
                              >
                              Submit
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={() => this._closeAWBConfirmModal('retrievalOfEDC')}
                                style={{marginRight:10,background:'rgb(255 0 0)',fontSize:10}}
                              >
                              Cancel
                              </button>
                            </div>
                          </form>
                      </>
                      : 
                      null
                    }
                    
                    {
                      this.state.retrievalType ==='not_available'?
                      <form onSubmit={(e)=>this._submitDataWhenTerminalNotAvailable(e)}>
                        <div style={{borderStyle:'none',borderWidth:1, padding:5, borderColor:'#ccc', borderRadius:3}}>
                          <Row className="show-grid">
                            <Col md={6}>
                              <p>Enter Store Manager name<span><sup style={{color:'#f00'}}>*</sup></span></p>
                              <input
                                type="text"
                                className="form-control input-sm"
                                id="idManagerName"
                                name="ManagerName"
                                maxLength="30"
                                required
                              />
                            </Col>
                            <Col md={6}>
                            
                              <p>Enter Store Manager Number<span><sup style={{color:'#f00'}}>*</sup></span></p>
                              <input
                                type="text"
                                className="form-control input-sm"
                                id="idManagerNumber"
                                name="ManagerNumber"
                                maxLength="10"
                                required
                              />
                            </Col>
                          </Row>

                          <div style={{marginTop:'65%',float:'right', marginBottom:20, paddingBottom:30}}>
                            <div>
                              <p id={'waitingTextROSubmit'}></p>
                            </div>
                            <button
                              className="btn btn-primary"
                              type={'submit'}
                              style={{marginRight:10,background:'rgb(140 40 127)',fontSize:10}}
                            >
                            Submit
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={() => this._closeAWBConfirmModal('retrievalOfEDC')}
                              style={{marginRight:10,background:'rgb(255 0 0)',fontSize:10}}
                            >
                            Cancel
                            </button>
                          </div>
                        </div>
                      </form>
                      :
                      null
                    }
                    
            </ModalBody>
          </Modal>

          <Modal id="myTicketsModal1" isOpen={this.state.modalIssue1}
                toggle={() => this._onclickModalmyTickets1("", "", "", "", "", "", "", "", "", "", "", "", "", "", "")}
                className="poc-modal-width">
            <ModalHeader toggle={() => this._onclickModaluploadfile("", "", "", "", "", "", "", "", "", "", "", "", "", "", "")} style={{backgroundColor:'rgb(114 40 127)'}}>
                Upload Job Sheet
            </ModalHeader>
              <ModalBody>
                <form>
                  <tr>
                    {/* <td><input className="form-control" id="fileButton" onChange={(e)=>this._jobSheethandleAndCompress(e)}  name ="uploadjobsheet" type="file" required={true} /></td> */}
                    <td><input className="form-control" id="fileButton" onChange={this.jobSheetChangedHandler}  name ="uploadjobsheet" type="file" required={true} /></td>
                  </tr>
                </form>
              </ModalBody>

            <ModalFooter>
              <Button style={{background:'rgb(243 127 26)'}} onClick={() => this.uploadJobSheet()}>Sumbit</Button>
              <Button style={{background:'rgb(140 40 127)'}}onClick={() => this._onclickModalmyTickets3("", "",)}>Cancel</Button>
            </ModalFooter>
          </Modal>

          
          {/* ------------------------------------------------------------------ */}
          {/* Modal to display ICM check UI Form */}
          <Modal id="invCheckModal" isOpen={this.state.invCheckModal} className="poc-modal-width" style={{position:''}}>
            <ModalHeader toggle={()=>this._closeInvCheckModal()} style={{backgroundColor:'rgb(114 40 127)'}}>Inventory Check</ModalHeader>
              <UtidSaveFormsComponent/>
          </Modal>
          
          {/* Notification when Successfull ICM Check process */}
          <Modal id="invCheckNote" isOpen={this.state.invCheckNote} className="poc-modal-width" style={{position:''}}>
            <ModalHeader style={{backgroundColor:'rgb(114 40 127)'}}>Notification</ModalHeader>
            <ModalBody>
              <p className="text-succesthis.state.onlyICMTcketData.map(s text-center">{this.state.invCheckNoteMessage}<br/>{this.state.icmCloseMessage}</p>
            </ModalBody>
            <ModalFooter>
              <Button style={{background:'rgb(243 127 26)'}} onClick={()=>this._closeInvNoteModal()}>Done</Button>
            </ModalFooter>
          </Modal>
          
          {/* Notification  from Serial number form */}
          <Modal id="invCheckNoteError" isOpen={this.state.invCheckNoteError} className="poc-modal-width" style={{position:''}}>
            <ModalHeader style={{backgroundColor:'rgb(114 40 127)'}}>Notification</ModalHeader>
            <ModalBody>
              <p className="text-danger text-center">{this.state.icmErrorMessage}</p>
            </ModalBody>
            <ModalFooter>
              <Button style={{background:'rgb(243 127 26)'}} onClick={()=>this._closeInvErrorModal()}>Done</Button>
            </ModalFooter>
          </Modal>
          
          {/* KYC Lite Camera modal Component */}
          <Modal id="invCheckImgUpload" isOpen={this.state.invCheckImgUpload} className="poc-modal-width" style={{position:''}}>
            <ModalHeader toggle={()=>this._closeinvCheckImgUpload()} style={{backgroundColor:'rgb(114 40 127)'}}>
              Upload Store Image
            </ModalHeader>
            <ModalBody style={(this.state.isMobile)?{height:'relative'}:{}}>

              <div className="container-fluid">
                <div className="embed-responsive embed-responsive-16by9" style={(this.state.isMobile)?{paddingBottom: '111.25%'}:{}}>
                    {
                      Boolean(this.state.imageDataURL)? 
                      (
                          <img className="embed-responsive-item" src={this.state.imageDataURL} alt="cameraPic" />
                      ): 
                      (
                          <video id="videoCanvas" className="embed-responsive-item" ref={(refrence) => {this.player = refrence;}} autoPlay></video>
                      )
                    }
                </div>
                <br/>
                <div className="text-center">
                    <Button
                        color="secondary"
                        style={{display:this.state.cameraSwitchButton,marginRight:10}} 
                        onClick={this._switchCamera}
                      >
                        <i className="pe-7s-switch" style={{fontSize:20}}></i>
                    </Button>
                    <Button color="danger" 
                        style={{display:this.state.cameraResetButton,marginRight:10}} 
                        onClick={this._initializeMedia}
                      >
                        <i className="pe-7s-close-circle"  style={{fontSize:20}}></i>
                    </Button>
                    <Button 
                        color="danger" 
                        style={{display:this.state.captureButton}}
                        {...this.state.captureImageButton} 
                        onClick={this._capturePicture}
                      >
                        <i className="pe-7s-camera" style={{fontSize:20}}></i>
                    </Button>
                    <Button
                        color="primary"
                        style={{display:this.state.finalUploadButton,color:(this.state.uploadingButtonMessage===''?'white':'red')}}
                        {...this.state.uploadImageButton} 
                        onClick={this._startUploadingStoreData}
                      >
                        <i className={this.state.uploadButtonName} style={{fontSize:20}}></i>
                        {this.state.uploadingButtonMessage}
                    </Button>
                </div>
              </div>
            </ModalBody>
          </Modal>
          {/* -------------------------------------------------------------------- */}
      </>
      )
    }


    //Component for Rendering Open Tickets except ICM Tickets
    const BindPaperRollTickets = (props) => {
      
      const cardStylePurple = {
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(114 40 127)',
      }

      const cardStyleOrange ={
        padding:'10px 10px 10px 10px',
        boxShadow: '0px 4px 8px -3px rgb(243 127 26)',
      }

      const isEven = (n)=>{
        if(n %2 === 0){
          return true;
        }
        return false;
      }

      const toggleOpenTicketView = ()=>{
        this.setState({
          openTicketView:  !this.state.openTicketView,
        });
      }

      return (
        <>
          <Button
            style={{background:'#72287f', marginBottom: '1rem', padding:12, fontSize:15}}
            className="poc-mainButtonWith" id="idMyOpenTickets"
            onClick={toggleOpenTicketView}
            
            >
            My Open Tickets ({this.state.totalMyTicketOpenCount})
            <span className="pull-right">
              <i className={(this.state.openTicketView)?"pe-7s-angle-down":"pe-7s-angle-right"} style={{fontSize:18}}></i>
            </span>
          </Button>
          <Collapse isOpen={this.state.openTicketView}>
            {
              (this.state.totalMyTicketOpenCount>0)?
                this.state.myTicketData.map((data, index)=>(
                  <Card style={(isEven(index))?cardStyleOrange:cardStylePurple} key={index}>
                    <CardBody className="">
                      <div>
                        <label style={{fontSize:13}}><b>Ticket Id: </b>{data.ticketId}</label>&nbsp;&nbsp;<label style={{fontSize:13}}>Priority: {data.priority}</label><br/>
                        <label style={{fontSize:13}}><b>UTID: </b>{data.utid}</label><br/>
                        <label style={{fontSize:13}}><b>Category: </b>{data.issueSubCategory}</label><br/>
                        <label style={{fontSize:13}}><b>Proactive Count: </b>{( data.proactiveChecks || 0)} </label>
                      </div>       
                      {/* Retrieval Tickets */}
                      {data.issueSubCategory.toLowerCase().includes("proactive paper roll")==true ?
                      
                        <>                 
                          {/* Buttons for PaperRoll Tickets */}
                          <div className="text-center" style={{marginTop:15}}>
                            <div className="btn-group mr-2">
                              <button className="btn btn-primary" style={{marginRight:10,background:'#72287f',fontSize:10}}
                                onClick={() => this._dispatchAndClosePaperRollTicket(data.ticketId, data.utid)}>Close Ticket
                              </button>
                              <button  className="btn btn-primary" style={{marginRight:10,background:'rgb(243 127 26)',fontSize:10}}
                                onClick={() => this._viewPaperRollTicketDetails(data.ticketId)}>View
                              </button>
                            </div>
                          </div>
                        </>

                        :

                        null
                      }
                    </CardBody>
                  </Card>
                ))
                :
                <Card style={cardStylePurple}>
                  <CardBody className="text-center">
                    <span style={{fontSize:12}}>You don't have open tickets</span>.
                  </CardBody>
                </Card>
            }
          </Collapse>
        </>
      )
    };

    const VirualSROJsx = ()=>{

      const ConfirmAWBAndDelivaryChallan = ()=>{

        return(
          <div>
            <ModalBody style={{overflowY: 'auto'}}>
              <React.Fragment>
                <Row className="show-grid" key={{}}>
              
                  <Col md={8}>
                    
                    {/* <div style={{}}>
                      <form onSubmit={{}} autoComplete="off">
                        <Row className="show-grid">
                          <Col md={6}>
                            <div className="form-group">
                            <label>Enter AWB Number</label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                id={"awbInitInput"}
                                name="serial_number"
                                maxLength={30}
                                placeholder="AWB number"
                                required
                              />
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="form-group">
                            <label>Confirm AWB Number</label>
                              <input
                                type="text"
                                className="form-control  input-sm"
                                id={"awbFinalInput"}
                                name="serial_number"
                                maxLength={30}
                                placeholder="Re-Enter AWB number"
                                required
                                onChange={()=>this._matchAwbNumbers()}
                              />
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </div> */}

                    <div style={{backgroudColor:'#f00'}}>
                    <table >
                      <tbody style={{fontSize:14}}>
                        <tr>
                          <td>Ticket Id</td>
                          <td>{this.state.paperRollTicketData[0].ticketId}</td>
                        </tr>
                        <tr>
                          <td>UTID</td>
                          <td>{this.state.paperRollTicketData[0].utid}</td>
                        </tr>
                        <tr>
                          <td>Issue category</td>
                          <td>{this.state.paperRollTicketData[0].issueSubCategory}</td>
                        </tr>
                        <tr>
                          <td>Quantity</td>
                          <td>{this.state.paperRollTicketData[0].quantity}</td>
                        </tr>
                        <tr>
                          <td>Merchant</td>
                          <td>{this.state.paperRollTicketData[0].merchant}</td>
                        </tr>
                      </tbody>
                    </table> 
                    </div>
                  </Col>

                  <Col md={4}>
                    
                  </Col>
                </Row>
              </React.Fragment>
            </ModalBody>
            <ModalFooter>
              <button
                disabled={false}
                id={'awbSubmitBtn'}
                onClick={() => this._submitAcceptAndCloseTicket()}
                className="btn btn-primary"
                style={{marginRight:10,background:'rgb(243 127 26)',fontSize:10,color:'#fff'}}
              >
                Confirm and Close
              </button>
              <Button style={{background:'rgb(140 40 127)'}} onClick={() => this._closeAWBConfirmModal('closure')}>Cancel</Button>
            </ModalFooter>
          </div>
        )
      }

      const TicketDetailsView = ()=>{
        return(
          <div>
            <ModalBody style={{overflowY: 'auto'}}>
              <React.Fragment>
                <Row className="show-grid" key={{}}>
              
                  <Col md={12}>
                    <table >
                      <tbody style={{fontSize:14}}>
                        <tr>
                          <td>Ticket Id</td>
                          <td>{this.state.paperRollTicketData[0].ticketId}</td>
                        </tr>
                        <tr>
                          <td>UTID</td>
                          <td>{this.state.paperRollTicketData[0].utid}</td>
                        </tr>
                        <tr>
                          <td>Issue category</td>
                          <td>{this.state.paperRollTicketData[0].issueSubCategory}</td>
                        </tr>
                        <tr>
                          <td>Quantity</td>
                          <td>{this.state.paperRollTicketData[0].quantity}</td>
                        </tr>
                        <tr>
                          <td>Merchant</td>
                          <td>{this.state.paperRollTicketData[0].merchant}</td>
                        </tr>
                        <tr>
                          <td>Chain</td>
                          <td>{this.state.paperRollTicketData[0].chain}</td>
                        </tr>
                        <tr>
                          <td>Store</td>
                          <td>{this.state.paperRollTicketData[0].store}</td>
                        </tr>
                        <tr>
                          <td>Store address</td>
                          <td>{this.state.paperRollTicketData[0].storeAddress}</td>
                        </tr>
                        <tr>
                          <td>Store City</td>
                          <td>{this.state.paperRollTicketData[0].storeCity}</td>
                        </tr>
                        <tr>
                          <td>Store PIN Code</td>
                          <td>{this.state.paperRollTicketData[0].storePincode}</td>
                        </tr>
                        <tr>
                          <td>Created At</td>
                          <td>{this.state.paperRollTicketData[0].createdAt}</td>
                        </tr>
                        <tr>
                          <td>Dispatch Time</td>
                          <td>{this.state.paperRollTicketData[0].dispatchTime}</td>
                        </tr>
                      </tbody>
                    </table>                    
                  </Col>
                </Row>
              </React.Fragment>
            </ModalBody>
            <ModalFooter>
              <Button style={{background:'rgb(140 40 127)'}} onClick={() => this._closeAWBConfirmModal('details_view')}>Done</Button>
            </ModalFooter>
          </div>
        )
      }

      const BulkTicketClosureModal = ()=>{
        return(
          <div>
            <ModalBody style={{overflowY: 'auto'}}>
              <React.Fragment>

                <Row className="show-grid" key={{}}>
                  <Col md={12}>
                    <label>
                      <span style={{color:'#000'}}>
                        Ticket ids in CSV {'(Comma separated values)'}  |
                      </span>
                      <span style={{color:'#000',marginLeft:5}}>
                        Total Ticket Count
                      </span>
                      <span style={{color:'#F00', marginLeft:8}} id={'ticketCount'}>
                      0
                      </span>
                    </label>
                    <textarea
                      id={'all_tickets'}
                      className="form-control"
                      rows="8"
                      onChange={(e)=>this._validateCSVs(e)}
                    >
                    </textarea>                 
                  </Col>
                </Row>

                <Row className="show-grid">
                  <Col md={12}>
                    <div style={{marginTop:20}}>
                      <p style={{color:'#f00'}} id={'csvValidationError'}></p>
                    </div>
                  </Col>
                </Row>

              </React.Fragment>

            </ModalBody>

            <ModalFooter>

              <Button
                className="btn btn-primary"
                id="submitClosureBtn"
                style={{background:'rgb(140 40 127)'}}
                onClick={()=> this._initializeBulkClosure('closureRequest')}
              >
                Submit
              </Button>

              <Button
                style={{background:'rgb(243 127 26)'}}
                onClick={() => this._closeAWBConfirmModal('bulk_closure')}
              >
                Cancel
              </Button>

            </ModalFooter>
          </div>
        )
      }

      return (

        <>
          {/* Main Container */}
          <div className="container-fluid bgcolor">

            <div className="row" style={{marginTop:10,}}>

              <div className="col-md-4">
                <button  className="btn btn-primary" style={{marginRight:10,background:'#72287f'}}
                  onClick={() => this._refreshPage()}>
                    <i className="pe-7s-refresh" style={{color:'#ffffff'}}></i>
                </button>

                <button
                  className="btn btn-primary"
                  style={{marginRight:10,background:'rgb(243, 127, 26)'}} 
                  >
                    <a href="/admin/logout/">
                      <i className="pe-7s-power" style={{color:'#ffffff'}}></i>
                    </a>
                </button>
              </div>
 
              <div className="col-md-8" style={{}}>
                <button
                  className="btn btn-primary"
                  style={{marginRight:10,background:'rgb(243, 127, 26)', float:'right'}}
                  onClick={()=>this._initializeBulkClosure('init')}
                >
                  Bulk Ticket Closure
                </button>
              </div>
            
            </div>

            <div className="row" style={{marginTop:20}}>
              {/* Main Content */}
              <div className="col-md-12">

                {/* rendring the My open tickets */}
                <BindPaperRollTickets/>


                <Button style={{background:'#72287f', marginBottom: '1rem',color:'white', padding:12, fontSize:15}} className="poc-mainButtonWith" id="StockSummary" disabled={false}>
                  My Stocks
                </Button>
                <UncontrolledCollapse toggler="#StockSummary">
                  <Card>
                    <CardBody className="poc-blockPadding">
                      <div className="poc-marginmainblock">
                        {this.state.myStockSummary.length > 0 ? "" : <label>There are no record to display</label>}
                        {bindMystockSummary}
                      </div>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>


                <Button style={{background:'#72287f',marginBottom: '1rem',color:'white', padding:12, fontSize:15}} className="poc-mainButtonWith" id="WorkOrder"  disabled={false}>
                  Work Order
                </Button>
                <UncontrolledCollapse toggler="#WorkOrder">
                  <Card>
                    <CardBody>
                      <div className="poc-marginmainblock">
                        <br/>
                        <div className="poc-workorder-head">Collect</div>
                        {this.state.collectWorkOrder.length > 0 ? "" : <label>There are no record to display</label>}
                        {bindCollectWorkOrder}
                        <div className="poc-workorder-head">Return</div>
                        {this.state.returnWorkOrder.length > 0 ? "" : <label>There are no record to display</label>}
                        {bindReturnWorkOrder}
                      </div>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>

              </div>
              
            </div>
          </div>

          {/* Support Modals */}
          <Modal id="confirmAWBModal" isOpen={this.state.confirmAWBModal} className="poc-modal-width" style={{position:''}}>
          <ModalHeader toggle={()=>this._closeAWBConfirmModal('closure')} style={{backgroundColor:'rgb(114 40 127)'}}>Please Confirm Closure</ModalHeader>
            <ConfirmAWBAndDelivaryChallan/>
          </Modal>

          <Modal id="confirmAWBModal" isOpen={this.state.AWBViewModal} className="poc-modal-width" style={{position:''}}>
          <ModalHeader toggle={()=>this._closeAWBConfirmModal('details_view')} style={{backgroundColor:'rgb(114 40 127)'}}>Ticket Details</ModalHeader>
            <TicketDetailsView/>
          </Modal>

          <Modal id="bulkClosure" isOpen={this.state.bulkClosure} className="poc-modal-width" style={{position:''}}>
          <ModalHeader toggle={()=>this._closeAWBConfirmModal('bulk_closure')} style={{backgroundColor:'rgb(114 40 127)'}}>Close Bulk Ticket</ModalHeader>
            <BulkTicketClosureModal/>
          </Modal>
        </>
      )
    }


    //main page JSX
    return (
      <>
        {/* Loader div */}
        <div id="loaderId" style={{...loading, display:this.state.loader}}>
          <div style={{display:'block',marginTop:'50%', left:'50%',position: 'fixed', marginTop: '100px', marginLeft: '-50px'}}>
            <img src={loaderGIF} height={100} width={100} />
            <p className="text-center" style={{color:'#72287f'}}>Loading...</p>
          </div>
        </div>
        {
          this._isVirtualSRO()?
          <VirualSROJsx/>
          : 
          <MainJsx/>
        }
      </>
   );
  }
}
export default InnovitiSupportModes;